/* global React, Icon, Card, Button, Switch, Badge, Modal, Field, Input, Select, Currency, toast, useState, useEffect, useRef */
// ============================================================
// PLUMME 2.0 — AI Regnskapsfører
// SuperPlumma jobber i bakgrunnen og gjør regnskapet klart.
// ============================================================
const AP_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'];
const AP_MONTHS_LONG = ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember'];
const apMonthShort = (index) => t('month.short.' + (Number(index) + 1), AP_MONTHS[Number(index)] || '');
const apMonthLong = (index) => {
  const monthIndex = Number(index);
  if (!Number.isInteger(monthIndex) || monthIndex < 0 || monthIndex > 11) return '';
  try {
    return new Intl.DateTimeFormat(PlummeI18n.intlLocale(), { month: 'long', timeZone: 'UTC' })
      .format(new Date(Date.UTC(2020, monthIndex, 1)));
  } catch (error) { return AP_MONTHS_LONG[monthIndex]; }
};
const apCurrentYear = () => new Date().getFullYear();
const apCurrentMonth = () => new Date().getMonth();
// Åpne på inneværende måned i inneværende år, ellers på desember i et avsluttet år.
const apDefaultMonth = (year) => Number(year) === apCurrentYear() ? apCurrentMonth() : 11;
// Sikkerhetsprosent vises bare når oppgaven faktisk har en. Backend-tasks har
// ingen reell score, og skal derfor ikke vise et tall i det hele tatt.
const apConfPct = (task) => typeof task?.conf === 'number'
  ? task.conf.toString().replace('.', ',') + ' %'
  : '';

// Tomme runtime-kontrakter: oppgaver, linjer og bilag kommer fra backend.
const AP_TASK_LINES={};
const AP_TASK_INBOX={};
function apKr(v) { return (v < 0 ? '−' : '') + Math.abs(v).toLocaleString(PlummeI18n.intlLocale(), { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr'; }
// Rediger en bokført føring fra "Vis"-dialogen
const AP_KONTO = ['1920 Bankinnskudd', '3000 Salgsinntekt', '3100 Salg utenfor avgiftsområdet', '4000 Varekjøp', '6300 Husleie', '6500 Verktøy og inventar', '6540 Programvare/abonnement', '7140 Reise og diett', '7350 Representasjon', '7700 Andre kostnader'];
function ApEditLineModal({ line, onClose, onSave, onCancelLine }) {
	  const [desc, setDesc] = useState(line.title || '');
	  const [konto, setKonto] = useState(() => { const m = AP_KONTO.find((k) => line.sub && line.sub.indexOf(k.slice(0, 4)) >= 0); return m || AP_KONTO[5]; });
	  const [mva, setMva] = useState(() => ({
	    vatRate: [25,15,12,0].find((rate)=>String(line.sub||'').includes(`${rate} %`)) ?? window.purchaseNewLineVatRate(),
	    reverseChargeCode: /snudd avgiftsplikt|kode 86/i.test(String(line.sub||'')) ? '86' : '',
	  }));
	  const [amount, setAmount] = useState(line.amount != null ? String(line.amount) : '0');
	  const gross = +amount || 0;
	  const save = () => { const mvaLabel=mva.reverseChargeCode==='86'?'MVA-kode 86':`${mva.vatRate} % MVA`;onSave({ ...line, title: desc || line.title, sub: konto + ' · ' + mvaLabel, amount: gross, status: line.status === 'kontroll' ? 'matchet' : line.status }); };
  return <Modal open onClose={onClose} title={t('bank.editEntry')} max={620}
    titleRight={<div style={{ textAlign: 'right' }}><div className="t-xs muted" style={{ fontWeight: 700 }}>{line.date}</div><div className="t-h2 t-num" style={{ color: gross < 0 ? 'var(--error)' : 'var(--success)' }}>{apKr(gross)}</div></div>}
    footer={<div className="row between" style={{ width: '100%', alignItems: 'center' }}><Button variant="ghost" icon="trash" onClick={onCancelLine}>{t('ap.cancelEntry')}</Button><div className="row gap-10"><Button variant="ghost" onClick={onClose}>{t('common.cancel')}</Button><Button icon="check" onClick={save} data-help={t('helpTopics.aiProposal.body')} data-help-title={t('helpTopics.aiProposal.title')}>{t('ap.saveEntry')}</Button></div></div>}>
    <div className="col gap-14" style={{ paddingBottom: 4 }}>
      <div className="alert" style={{ background: 'var(--plum-50)', border: '1px solid var(--plum-200)', borderRadius: 'var(--r-md)', padding: '13px 15px' }}>
        <div><b>{t('ap.suggestion')}</b><div className="t-sm" style={{ fontWeight: 600, color: 'var(--ink-2)', marginTop: 3 }}>{t('ap.suggestionOverrideNote', 'Du kan endre konto, MVA og beløp før du godkjenner. Endringen overstyrer autopilotens forslag.')}</div></div>
      </div>
      <Field label={t('sale.lines.description')}><Input value={desc} onChange={(e) => setDesc(e.target.value)} placeholder={t('voucher.whatFor')} /></Field>
      <div className="grid-2 gap-14">
        <Field label={t('voucher.account')} help={t('helpTopics.accountChoice.body')} helpTitle={t('helpTopics.accountChoice.title')}><Select value={konto} onChange={(e) => setKonto(e.target.value)}>{AP_KONTO.map((k) => <option key={k}>{k}</option>)}</Select></Field>
	        <Field label={t('voucher.vatCode')} help={t('helpTopics.vatTreatment.body')} helpTitle={t('helpTopics.vatTreatment.title')}><window.PurchaseVatTreatmentSelect vatRate={mva.vatRate} reverseChargeCode={mva.reverseChargeCode} onChange={setMva}/></Field>
      </div>
      <Field label={t('ap.amountIncVat')}><Currency value={amount} onChange={(e) => setAmount(e.target.value)} /></Field>
    </div>
  </Modal>;
}

function ApContactsModal({ task, busy, onClose, onExecute, onSkipItem }) {
  const cfg = task.id === 'kunder'
    ? { title: t('inv.report.tile.newCustomers', 'Nye kunder'), noun: 'kunde', list: 'kundelisten', icon: 'users', type: 'customer' }
    : { title: t('ap.contactsNewSuppliersTitle', 'Nye leverandører'), noun: 'leverandør', list: 'leverandørlisten', icon: 'building', type: 'supplier' };
  const [items, setItems] = useState(() => (task.lines || []).map((line) => ({ id: line.id, originalName: line.title, name: line.title, organizationNumber: '', source: line.sub })));
  const [skipItem, setSkipItem] = useState(null);
  const active = items.filter((item) => item.name.trim());
  const update = (id, patch) => setItems((current) => current.map((item) => item.id === id ? { ...item, ...patch } : item));
  const saveAll = () => {
    onExecute(task, active.map((item) => ({ type: cfg.type, originalName: item.originalName, name: item.name.trim(), organizationNumber: item.organizationNumber.trim() })));
    onClose();
  };
  return <Modal open onClose={onClose} title={cfg.title} max={680}
    titleRight={apConfPct(task) ? <span className="t-sm muted" style={{ fontWeight: 700 }}>{t('apu.confidence', { pct: apConfPct(task) })}</span> : null}
    footer={<React.Fragment><Button variant="ghost" onClick={onClose}>{t('common.close')}</Button><Button icon="check" disabled={!active.length} onClick={saveAll} data-help={t('helpTopics.aiProposal.body')} data-help-title={t('helpTopics.aiProposal.title')}>{t('ap.contactsCreateSelected', 'Opprett valgte ({{count}})', { count: active.length })}</Button></React.Fragment>}>
    <div className="col gap-14" style={{ paddingBottom: 4 }}>
      <div className="ap-skatt-banner" style={{ background: 'var(--plum-50)', border: '1px solid var(--plum-200)' }}>
        <Icon name={cfg.icon} size={22} style={{ color: 'var(--plum-700)', flex: 'none' }} />
        <div><b>{t('ap.contactsProposedCount', '{{count}} {{noun}} foreslått', { count: items.length, noun: items.length === 1 ? cfg.noun : cfg.noun + 'er' })}</b><div className="t-sm" style={{ fontWeight: 600, marginTop: 2 }}>{t('ap.contactsFoundNote', 'SuperPlumma fant føringer uten registrert {{noun}}. Lagre dem i {{list}} så framtidige føringer kobles automatisk.', { noun: cfg.noun, list: cfg.list })}</div></div>
      </div>
      <div className="col gap-10">{items.map((c) => <div key={c.id} className="ap-contact">
        <span className="ap-asset-ico"><Icon name={cfg.icon} size={18} /></span>
        <div className="grow" style={{ minWidth: 0 }}>
          <div className="grid-2 gap-8"><Input value={c.name} onChange={(event) => update(c.id, { name: event.target.value })}/><Input value={c.organizationNumber} placeholder={t('set.orgNumber', 'Organisasjonsnummer')} onChange={(event) => update(c.id, { organizationNumber: event.target.value })}/></div>
          <div className="t-sm muted" style={{ fontWeight: 600, marginTop: 5 }}>{c.source}</div>
        </div>
        <Button size="sm" variant="ghost" disabled={busy} onClick={() => setSkipItem({ id: c.id, title: c.name })}>{t('ap.skip')}</Button>
      </div>)}</div>
      <window.ApSkipChoiceModal item={skipItem} busy={busy} onClose={() => setSkipItem(null)} onChoose={async (mode) => {
        if (await onSkipItem(task.id, skipItem.id, mode)) setItems((current) => current.filter((item) => item.id !== skipItem.id));
        setSkipItem(null);
      }} />
    </div>
  </Modal>;
}

// inline preview of an attached bilag (receipt/invoice), shown/hidden per line
function ApBilagPreview({ line }) {
  return <div className="ap-bilag-preview">
    <div className="ap-bilag-doc">
      <div className="ap-bilag-doc-hd">
        <span className="ap-bilag-doc-ico"><Icon name="fileText" size={16} /></span>
        <div style={{ minWidth: 0 }}>
          <div className="ap-bilag-doc-name">{line.bilag}</div>
          <div className="ap-bilag-doc-sub">{line.title} · {line.date}.2026</div>
        </div>
      </div>
      <div className="ap-bilag-doc-rows">
        <div><span>{t('asset.supplier')}</span><strong>{line.title}</strong></div>
        <div><span>{t('voucher.entryDate')}</span><strong>{line.date}.2026</strong></div>
        <div><span>{t('ap.amountIncVatShort')}</span><strong>{apKr(Math.abs(line.amount))}</strong></div>
      </div>
      <button className="ap-bilag-doc-ft" onClick={() => toast(t('ap.openingVoucher', 'Åpner {{name}}', { name: line.bilag }), 'info')}><Icon name="eye" size={13} />{t('ap.openVoucherFull')}</button>
    </div>
  </div>;
}

// Agenttitler markerer perioden med `**...**` (se `apAgentPeriodStrong`), slik
// at «august 2026» leses som en periode og ikke som en del av setningen. All
// annen tekst går uendret gjennom.
const apRichText = (text) => String(text == null ? '' : text)
  .split(/\*\*(.+?)\*\*/)
  .map((part, index) => (index % 2 ? <strong key={index} className="ap-period">{part}</strong> : part));

function ApLinesModal({ task, approved, reopenable, busy, onClose, onApprove, onReopen, onOpenSurface, onUpdateProposal, onIgnoreItem, onExecute, onExecuteLine, onAttachReceipt, onSaveMileage }) {
  if (task.id === 'faktura') return <window.ApInvoiceAgentModal task={task} busy={busy} onClose={onClose} onExecute={onExecute} onSkipItem={onIgnoreItem} />;
  if (task.id === 'followup-customer-followup') return <window.ApCustomerFollowupModal task={task} busy={busy} onClose={onClose} onSkipItem={onIgnoreItem} />;
  const isBilag = task.id === 'bilag' || task.agentKey === 'bokforing';
  const [filter, setFilter] = useState('alle');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [lines, setLines] = useState(() => (task.lines || AP_TASK_LINES[task.id] || []).map((l) => ({ ...l })));
  const [inbox, setInbox] = useState(() => (task.inbox || AP_TASK_INBOX[task.id] || []).map((d) => ({ ...d })));
  const [dragDoc, setDragDoc] = useState(null);
  const [overLine, setOverLine] = useState(null);
  const [editLine, setEditLine] = useState(null);
  const [skipItem, setSkipItem] = useState(null);
  const isLonn = task.id === 'lonn' || task.id === 'amelding';
  const [openBilag, setOpenBilag] = useState(() => new Set());
  const toggleBilag = (id) => setOpenBilag((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const hasKontroll = lines.some((l) => l.status === 'kontroll');
  const hasMangler = lines.some((l) => l.status === 'mangler');
  const hasAvvik = lines.some((l) => l.status === 'avvik');
  const counts = {
    alle: lines.length,
    matchet: lines.filter((l) => l.status === 'matchet' || l.status === 'godkjent').length,
    avvik: lines.filter((l) => l.status === 'avvik').length,
    kontroll: lines.filter((l) => l.status === 'kontroll').length,
    mangler: lines.filter((l) => l.status === 'mangler').length,
  };
  const FILTERS = [['alle', t('ap.review.all', 'Alle')]];
  if (counts.matchet > 0) FILTERS.push(['matchet', isBilag ? t('ap.review.withVoucher', 'Med bilag') : t('ap.review.matched', 'Matchet')]);
  if (hasMangler) FILTERS.push(['mangler', t('ap.review.missingVoucher', 'Mangler bilag')]);
  if (hasKontroll) FILTERS.push(['kontroll', t('ap.review.needsChecking', 'Trenger kontroll')]);
  if (hasAvvik) FILTERS.push(['avvik', t('ap.review.createsDeviation', 'Skaper avvik')]);

  const matching = lines.filter((l) => filter === 'alle'
    || l.status === filter
    || (filter === 'matchet' && l.status === 'godkjent'));
  // Lista var kappet til 8 linjer uten at noe sa ifra. Nå kommer alle linjene
  // hit, og de sideles med samme komponent som resten av appen — sa «40 av 312»
  // staar der i stedet for at 304 linjer forsvinner i stillhet.
  const pages = Math.max(1, Math.ceil(matching.length / pageSize));
  const safePage = Math.min(page, pages);
  const from = matching.length ? (safePage - 1) * pageSize + 1 : 0;
  const to = Math.min(safePage * pageSize, matching.length);
  const shown = matching.slice((safePage - 1) * pageSize, safePage * pageSize);
  const edge = (s) => ['matchet', 'godkjent'].includes(s) ? 'var(--success)' : s === 'kontroll' ? 'var(--warning)' : ['avvik', 'critical'].includes(s) ? 'var(--error)' : 'var(--border-strong)';

  // Sendeknappen hoerer til linjen, ikke bare til samleknappen nederst: skal du
  // sende en faktura og la resten ligge, maa valget staa paa raden. Den vises
  // for de linjene backend faktisk kan sende — utkast maa ferdigstilles
  // foerst — og gjelder like mye naar linjene kommer fra regnskapet som fra
  // eksempeldata.
  const isSendTask = ['faktura', 'purring'].includes(task.id);
  const sendLabel = task.id === 'purring' ? t('ap.sendReminder', 'Send påminnelse') : t('ap.sendInvoice', 'Send faktura');
  const canSendLine = (line) => isSendTask && Boolean(onExecuteLine) && Boolean(task.execution?.invoiceIds?.includes(line.id));
  const lineHasActions = (line) => task.skippable || canSendLine(line) || (line.status === 'kontroll' && !task.backendBacked);

  const attach = async (lineId, docId) => {
    const doc = inbox.find((d) => d.id === docId); if (!doc) return;
    const line = lines.find((entry) => entry.id === lineId);
    if (task.queueGroup && line?.queueTask && onAttachReceipt) {
      const linked = await onAttachReceipt(line.queueTask.statementId, line.queueTask.sourceId, docId);
      if (!linked) return;
    }
    setLines((ls) => ls.map((l) => l.id === lineId ? { ...l, status: 'matchet', bilag: doc.name, sub: t('apu.linkedManually') } : l));
    setInbox((ds) => ds.filter((d) => d.id !== docId));
    setDragDoc(null); setOverLine(null);
    toast(t('apu.voucherLinked', { name: doc.name }), 'success');
  };

  const taskSummary = <div className="ap-task-summary">
    <div className="ap-task-summary-head">
      <span className="ap-row-ico"><Icon name={task.icon || 'sparkle'} size={20} /></span>
      <div>
        <div className="t-h3" style={{ fontSize: 15 }}>{apRichText(task.title)}</div>
        <div className="t-sm muted" style={{ fontWeight: 650 }}>{task.desc}</div>
      </div>
    </div>
    {task.detail && <div className="ap-task-summary-detail">{String(task.detail).split('\n').map((line, index) => <p key={index}>{line}</p>)}</div>}
    <div className="ap-task-summary-grid">
      <div><span>{t('inv.col.status')}</span><b>{task.requiresCorrection ? t('ap.followup.mustCorrect', 'Må korrigeres') : task.status === 'done' ? t('ap.review.upToDate') : task.status === 'approved' ? t(window.PlummeAutopilotReview.statusKey(task)) : task.status === 'blocked' ? t('ap.review.blocked') : task.status === 'waiting' ? t('ap.waiting') : task.status === 'needs_review' ? t('ap.review.needsChecking') : task.status === 'idle' ? t('ap.nothingToCheck') : t('ap.review.ready')}</b></div>
      <div><span>{t('vat.basis')}</span><b>{task.backendBacked ? t('ap.review.yourAccounts') : t('ap.review.exampleData')}</b></div>
      {apConfPct(task) && <div><span data-help={t('helpTopics.security.body')} data-help-title={t('helpTopics.security.title')}>{t('ap.security')}</span><b>{apConfPct(task)}</b></div>}
    </div>
  </div>;

  const linesList = <div className="col gap-10">
    {shown.length === 0
      ? taskSummary
      : shown.map((l) => <div key={l.id} className={'bank-line' + (l.status === 'mangler' ? ' ap-line-mangler' : '') + (overLine === l.id ? ' drop-over' : '')} style={{ borderLeft: '4px solid ' + edge(l.status) }}
        onDragOver={(e) => { if (dragDoc) { e.preventDefault(); if (overLine !== l.id) setOverLine(l.id); } }}
        onDragLeave={() => setOverLine((o) => o === l.id ? null : o)}
        onDrop={(e) => { e.preventDefault(); if (dragDoc) void attach(l.id, dragDoc); }}>
        <div className="row between gap-12" style={{ alignItems: 'flex-start' }}>
          <div data-app-control="true" className="row gap-12 ap-line-click" style={{ minWidth: 0, cursor: 'pointer' }}
            onClick={() => isLonn ? (onClose(), onOpenSurface(task)) : (task.queueGroup || task.id === 'kjorebok') ? setEditLine(l) : window.plummeNav?.(l.route || task.route)}
            title={isLonn ? t('ap.clickToSeePayslipLines') : (task.queueGroup || task.id === 'kjorebok') ? t('ap.clickToEditProposal') : t('ap.clickToOpenWorkArea')}>
            <span className={'bank-tick ' + (['matchet', 'godkjent'].includes(l.status) ? 'matchet' : l.status === 'kontroll' ? 'forslag' : ['avvik', 'critical'].includes(l.status) ? 'privat' : 'privat')} style={['avvik', 'critical'].includes(l.status) ? { background: 'var(--error-bg)', color: 'var(--error)' } : null}>
              {['matchet', 'godkjent'].includes(l.status) ? <Icon name="check" size={14} stroke={3} /> : l.status === 'kontroll' ? <Icon name="alertCircle" size={14} /> : ['avvik', 'critical'].includes(l.status) ? <Icon name="alertTri" size={14} /> : <Icon name="fileText" size={13} />}
            </span>
            <span className="t-sm muted" style={{ fontWeight: 800, minWidth: 52 }}>{l.date}</span>
            <div style={{ minWidth: 0 }}>
              <div className="t-h3 ap-line-title" style={{ fontSize: 14 }}>{l.title}{(!task.backendBacked || task.queueGroup) && <Icon name={isLonn ? 'eye' : 'pencil'} size={13} className="ap-line-pencil" />}</div>
              <div className="t-sm muted" style={{ fontWeight: 600 }}>{l.sub}</div>
              {l.status === 'kontroll' && l.note && <div className="t-sm" style={{ fontWeight: 600, color: 'var(--warning)', marginTop: 4 }}>{l.note}</div>}
              {l.status === 'avvik' && l.note && <div className="t-sm" style={{ fontWeight: 600, color: 'var(--error)', marginTop: 4 }}>{l.note}</div>}
            </div>
          </div>
          {(l.amount != null || task.kind !== 'frister') && <div style={{ textAlign: 'right', flex: 'none' }}>
            {l.amount != null && <div className="t-h3 t-num" style={{ color: l.amount < 0 ? 'var(--error)' : 'var(--success)' }}>{apKr(l.amount)}</div>}
            {task.kind !== 'frister' && <div style={{ marginTop: 5 }}>
              <span className={'pp ' + (l.status === 'matchet' ? 'pp-paid' : l.status === 'kontroll' ? 'pp-warn' : ['avvik', 'critical'].includes(l.status) ? 'pp-unpaid' : 'pp-muted')}>
                {l.status === 'godkjent' ? t('ap.approved', 'Godkjent') : l.status === 'matchet' ? (isBilag ? t('ap.review.voucherLinked', '✓ Bilag koblet') : t('ap.review.ready', 'Klar')) : l.status === 'kontroll' ? t('ap.review.needsChecking', 'Trenger kontroll') : l.status === 'critical' ? t('ap.followup.mustCorrect', 'Må korrigeres') : l.status === 'avvik' ? t('ap.review.createsDeviation', 'Skaper avvik') : t('ap.review.missingVoucher', 'Mangler bilag')}
              </span>
            </div>}
          </div>}
        </div>
        {l.status === 'matchet' && l.bilag && <div style={{ marginTop: 11, paddingLeft: 64 }}>
          <button className="bank-attach ap-bilag-toggle" style={{ borderStyle: 'solid', borderColor: 'var(--success-bd)', background: 'var(--success-bg)', color: 'var(--success)' }} onClick={() => toggleBilag(l.id)}>
            <Icon name="fileText" size={14} />{l.bilag}
            <span className="ap-bilag-toglbl"><Icon name={openBilag.has(l.id) ? 'chevUp' : 'eye'} size={13} />{openBilag.has(l.id) ? t('ap.review.hideVoucher', 'Skjul bilag') : t('ap.review.showVoucher', 'Vis bilag')}</span>
          </button>
          {openBilag.has(l.id) ? <ApBilagPreview line={l} /> : null}
        </div>}
        {l.status === 'mangler' && <div className="row gap-8 wrap" style={{ marginTop: 11, paddingLeft: 64, alignItems: 'center' }}>
          <span className="bank-attach"><Icon name="files" size={14} />{t('ap.dragVoucherHere')}</span>
        </div>}
        {lineHasActions(l) && <div className="row gap-8 wrap" style={{ marginTop: 11, paddingLeft: 64, justifyContent: 'flex-end' }}>
          {task.skippable && !l.requiresCorrection && <Button size="sm" variant="ghost" onClick={() => setSkipItem({ id: l.id, title: l.title })}>{t('ap.skip')}</Button>}
          {canSendLine(l) && <Button size="sm" icon="send" onClick={() => onExecuteLine(task, l.id)}>{sendLabel}</Button>}
          {isSendTask && !task.backendBacked && <Button size="sm" variant="secondary" onClick={async () => {
            if (await onIgnoreItem(task.id, l.id)) setLines((current) => current.filter((line) => line.id !== l.id));
          }}>{t('ap.ignoreThisMonth', 'Ignorer denne måneden')}</Button>}
          {!isSendTask && !task.backendBacked && <Button size="sm" variant="secondary" icon="eye" onClick={() => window.plummeNav?.(l.route || task.route)}>{t('inv.act.open')}</Button>}
        </div>}
      </div>)}
    {matching.length > pageSize && <Pagination page={safePage} pages={pages} onPage={setPage}
      total={matching.length} from={from} to={to} pageSize={pageSize}
      onPageSize={(size) => { setPageSize(size); setPage(1); }} />}
  </div>;

  const inboxPanel = <Card style={{ alignSelf: 'flex-start' }}>
    <div className="row between" style={{ marginBottom: 8 }}>
      <div className="row gap-8" style={{ alignItems: 'center' }}><Icon name="inbox" size={18} /><b className="t-h3" style={{ fontSize: 16 }}>{t('nav.inbox')}</b></div>
      <span className="pp pp-credit">{inbox.length}</span>
    </div>
    <div className="t-sm muted" style={{ fontWeight: 600, marginBottom: 12 }}>{t('ap.dragVoucherOntoLine')}</div>
    <div className="col gap-10">{inbox.length === 0
      ? <div className="t-sm muted" style={{ fontWeight: 600, textAlign: 'center', padding: '20px 0' }}>{t('ap.review.allVouchersLinked', 'Alle bilag er koblet 🎉')}</div>
      : inbox.map((d) => <div key={d.id} className="bank-doc" draggable onDragStart={() => setDragDoc(d.id)} onDragEnd={() => { setDragDoc(null); setOverLine(null); }} style={{ opacity: dragDoc === d.id ? 0.5 : 1, cursor: 'grab' }}>
        <span className="icon-chip" style={{ background: 'var(--panel)', flex: 'none' }}><Icon name="fileText" size={18} /></span>
        <div className="grow" style={{ minWidth: 0 }}>
          <div className="t-h3" style={{ fontSize: 13.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{d.name}</div>
          <div className="t-xs muted" style={{ fontWeight: 600 }}>{d.meta}</div>
        </div>
        <Icon name="grip" size={16} className="muted" />
      </div>)}</div>
  </Card>;

  return <Modal open onClose={onClose} title={apRichText(task.title)} max={isBilag ? 1040 : 760}
    titleRight={apConfPct(task) ? <span className="t-sm muted" style={{ fontWeight: 700 }}>{t('apu.confidence', { pct: apConfPct(task) })}</span> : null}
    footer={<React.Fragment>
      <Button variant="ghost" onClick={onClose}>{t('common.close')}</Button>
      {/* Send alle. Samme handling som knappen paa raden bak modalen, men her
          staar den ved siden av godkjenningen — kontrollerte du linjene her
          inne, skal du kunne sende dem herfra uten aa lukke og finne raden
          igjen. Den gaar innom den samme bekreftelsen som alt annet utgaaende. */}
      {!approved && !task.queueGroup && task.execution && onExecute && <Button variant="secondary" icon="send"
        onClick={() => { onClose(); onExecute(task); }}>{task.execution.label}</Button>}
      {/* Én godkjenn-knapp uansett oppgavetype. `approveAutopilotTask` bokfører
          køoppgaven direkte, og sender resten videre til flaten der
          godkjenningen faktisk skjer — med en toast som sier ifra. */}
      {/* Er oppgaven allerede godkjent, er det ingenting å signere på her. Da
          angrer knappen godkjenningen i stedet, slik at oppgaven kan tas opp
          igjen — en signatur brukeren ikke kommer ut av, tør de ikke gi. */}
      {approved && !task.queueGroup
        ? reopenable && onReopen && <Button variant="secondary" icon="refresh" onClick={() => { void onReopen(task.id); onClose(); }}>
            {t('ap.reopenTask', 'Angre godkjenning')}
          </Button>
        : task.requiresCorrection && onOpenSurface
        ? <Button icon="arrowRight" onClick={() => { onClose(); onOpenSurface(task); }}>
            {t('ap.followup.correctInSettings', 'Korriger i innstillinger')}
          </Button>
        : task.id === 'frister' && onOpenSurface
        ? <Button icon="arrowRight" onClick={() => { onClose(); onOpenSurface(task); }}>{t('ap.agent.deadline.action')}</Button>
        : apTaskNeedsRealSubmission(task) && onOpenSurface
        // MVA godkjennes ikke med en signatur her — den godkjennes ved at
        // meldingen faktisk opprettes, sendes inn og signeres. Sto «Godkjenn»
        // her, hakket den av en oppgave Skatteetaten aldri fikk noe av.
        ? <Button icon="arrowRight" onClick={() => { onClose(); onOpenSurface(task); }}>
            {t('ap.openVatReturn', 'Åpne MVA-meldingen')}
          </Button>
        : task.status !== 'waiting' && (!task.backendBacked || task.approvable || task.route || task.status === 'idle') &&
        <Button icon="check" onClick={() => { void onApprove(task.id); onClose(); }}>
          {task.queueGroup
            ? t('ap.approveAndBookProposals', 'Godkjenn og bokfør {{count}} forslag', { count: task.readyCount || 0 })
            : t('ap.approveTask')}
        </Button>}
    </React.Fragment>}>
    <div className="col gap-14" style={{ paddingBottom: 4 }}>
      {!['frister', 'oppfolging'].includes(task.kind) && <div className="row gap-8 wrap">{FILTERS.map(([k, l]) => <button key={k} className={'bank-chip' + (filter === k ? ' on' : '')} onClick={() => { setFilter(k); setPage(1); }}>{l}<span className="bank-chip-n">{counts[k]}</span></button>)}</div>}
      {isBilag ? <div className="ap-rec"><div style={{ minWidth: 0 }}>{linesList}</div>{inboxPanel}</div> : linesList}
    </div>
    <window.ApSkipChoiceModal item={skipItem} busy={busy} onClose={() => setSkipItem(null)} onChoose={async (mode) => {
      if (await onIgnoreItem(task.id, skipItem.id, mode)) setLines((current) => current.filter((line) => line.id !== skipItem.id));
      setSkipItem(null);
    }} />
    {editLine && !task.backendBacked && task.id !== 'kjorebok' && <ApEditLineModal line={editLine} onClose={() => setEditLine(null)}
      onCancelLine={() => { setLines((ls) => ls.filter((x) => x.id !== editLine.id)); setEditLine(null); toast(t('ap.entryCancelled', 'Føringen ble annullert'), 'success'); }}
      onSave={(nl) => { setLines((ls) => ls.map((x) => x.id === nl.id ? nl : x)); setEditLine(null); toast(t('ap.entryUpdated', 'Føring oppdatert 🟣'), 'success'); }} />}
    {editLine && task.queueGroup && window.ApQueueProposalModal && <window.ApQueueProposalModal line={editLine} busy={busy} onClose={() => setEditLine(null)}
      onSave={async (taskId, proposal) => {
        const updated = await onUpdateProposal(taskId, proposal);
        if (updated) setLines((current) => current.map((line) => line.id === taskId ? window.apQueueLineFromTask(updated) : line));
        setEditLine(null);
      }} />}
    {editLine && task.id === 'kjorebok' && window.ApMileageEditModal && <window.ApMileageEditModal line={editLine} busy={busy} onClose={() => setEditLine(null)}
      onSave={async (value) => {
        if (await onSaveMileage(value)) setLines((current) => current.filter((line) => line.id !== value.id));
        setEditLine(null);
      }} />}
  </Modal>;
}

function ApStat({ label, value, tone, help }) {
  return <div className="ap-stat" {...(help ? { 'data-help': help, 'data-help-title': label } : {})}>
    <div className="ap-stat-label">{label}</div>
    <div className={'ap-stat-value' + (tone ? ' ' + tone : '')}>{value}</div>
  </div>;
}

const AP_TASK_PERM = {
  'month-control': 'bokforing', bank: 'bokforing', bilag: 'bilag', eiendeler: 'eiendeler', leverandorer: 'leverandorer', kunder: 'kunder',
  lonn: 'lonn', amelding: 'lonn', mva: 'mva', skatt: 'skatt', arsregnskap: 'arsregnskap',
  innboks: 'innboks', faktura: 'faktura', purring: 'purring', avstemming: 'avstemming',
  kontroll: 'kontroll', frister: 'frister', kjorebok: 'kjorebok', bilagsmatch: 'bilag', oppfolging: 'oppfolging',
};
const AP_WORKFLOW_ORDER = {
  leverandorer: 10,
  kunder: 20,
  eiendeler: 30,
  lonn: 40,
  innboks: 50,
  bilag: 60,
  bokforing: 70,
  mva: 80,
  avstemming: 90,
  kontroll: 100,
  kjorebok: 110,
  frister: 120,
  skatt: 130,
  arsregnskap: 140,
  faktura: 210,
  purring: 220,
  oppfolging: 230,
};
const AP_WORKFLOW_BLOCKING = new Set(['leverandorer', 'kunder', 'eiendeler', 'lonn', 'innboks', 'bilag', 'bokforing', 'mva', 'avstemming', 'kontroll']);
const apTaskWorkflowRank = (task) => AP_WORKFLOW_ORDER[apTaskPermKey(task)] || 999;
const apSortWorkflowTasks = (tasks) => [...tasks].sort((a, b) => apTaskWorkflowRank(a) - apTaskWorkflowRank(b));
const apTaskNeedsWork = (task) => ['ready', 'needs_review', 'blocked', 'waiting', 'approved'].includes(String(task?.status || ''));
const apTaskBlocksWorkflow = (task) => AP_WORKFLOW_BLOCKING.has(apTaskPermKey(task)) && apTaskNeedsWork(task);
// Backend-tasks har egne id-er (`bank`, `mva`, `followup-inbox` …). Uten denne
// mappingen slo `AP_TASK_PERM` bom på alle oppfølgingstasks, og en avslått agent
// fjernet dem ikke fra listen. `purchases` og `other-sales` har fortsatt ingen
// egen agent og filtreres bevisst ikke.
// `reporting` staar ikke her lenger: den gruppa blir ikke en egen rad, men
// linjer paa Fristagenten — som filtreres paa sin egen `frister`-noekkel.
const AP_FOLLOWUP_PERM = {
  inbox: 'innboks', suppliers: 'leverandorer', bank: 'bokforing',
  sales: 'faktura', offers: 'faktura', 'customer-followup': 'oppfolging',
};
const apTaskPermKey = (task) => {
  if (!task?.id) return undefined;
  if (task.queueGroup && task.agentKey) return task.agentKey;
  // Oppgaver fra backend-koen har egne typer i stedet for id-ene i AP_TASK_PERM.
  if (task.type === 'receipt_bookkeeping') return 'bilag';
  if (task.type === 'bank_bookkeeping') return 'bokforing';
  if (String(task.id).startsWith('followup-')) return AP_FOLLOWUP_PERM[String(task.id).slice('followup-'.length)];
  return AP_TASK_PERM[task.id];
};
function apTaskAgentLabel(task) {
  if (task?.id === 'followup-customer-followup') return t('ap.customerFollowup.title', 'Kundeoppfølging');
  const key = apTaskPermKey(task); const localized = { bokforing: ['ap.agentName.bookkeeping', 'Bokføringsagenten'], skatt: ['ap.agentName.tax', 'Skatteagenten'], arsregnskap: ['ap.agentName.annual', 'Årsregnskapsagenten'] }[key];
  if (task?.monthControl) return t('ap.monthControl.label', 'M\u00e5nedskontroll');
  if (localized) return t(localized[0], localized[1]);
  const perm = AP_PERMS.find((agent) => agent.key === key);
  return (perm && (perm.labelKey ? t(perm.labelKey, perm.label) : perm.label)) || task.agentLabel || task.agentName || task.title;
}
const AP_TASK_ROUTE = {
  bank: 'bank', bilag: 'innboks', eiendeler: 'eiendeler', leverandorer: 'leverandorer', kunder: 'kunder',
  lonn: 'lonn', amelding: 'lonn', mva: 'innsendinger', skatt: 'skattemelding', arsregnskap: 'arsregnskap',
  innboks: 'innboks', faktura: 'fakturaliste', purring: 'fakturaliste', avstemming: 'bank',
  kontroll: 'allebilag', frister: 'innsendinger', kjorebok: 'kjorebok', bilagsmatch: 'bank',
};
// NB: her lå tidligere en bankvelger-modal med hardkodet bankliste og et
// hardkodet kontonummer. Den koblet ingenting — Plumme har ingen open
// banking-/PSD2-integrasjon. Bankdata kommer fra bankutskrifter importert på
// Bank-flaten, og statuskortet lenger nede viser nettopp det.

// NB: propen kan ikke hete `t` - den ville skygge for den globale t().
// Bekreftelse før noe faktisk bokføres. Bokføring er ikke reversibel med et
// angreklikk, så handlingen skal ikke ligge ett uhell unna i en oppgaveliste.
function ApExecuteModal({ task, running, onConfirm, onClose }) {
  return <Modal open onClose={running ? () => {} : onClose} title={task.execution.confirmTitle || t('ap.execute.title', 'Bokfør fra AI Regnskapsfører')} max={540}
    footer={<React.Fragment>
      <Button variant="ghost" disabled={running} onClick={onClose}>{t('common.cancel')}</Button>
      <Button icon="check" disabled={running} onClick={onConfirm}>
        {running ? t('ap.execute.running', 'Bokfører …') : task.execution.label}
      </Button>
    </React.Fragment>}>
    <div className="col gap-14" style={{ paddingBottom: 4 }}>
      <div className="ap-skatt-banner warn">
        <Icon name="alertCircle" size={22} />
        <div>
          <b>{task.execution.confirmTitle ? t('ap.execute.warnTitleGeneric', 'Dette kan ikke angres') : t('ap.execute.warnTitle', 'Dette bokfører i regnskapet ditt')}</b>
          <div className="t-sm" style={{ fontWeight: 600, marginTop: 2 }}>
            {task.execution.confirmWarn || t('ap.execute.warnBody', 'Bilagene føres som kjøp med konto, MVA og betalingsmåte fra bilagsanalysen. Du er ansvarlig for at føringene er riktige, og må annullere manuelt hvis noe blir feil.')}
          </div>
        </div>
      </div>
      <div className="t-sm muted" style={{ fontWeight: 600 }}>
        {task.execution.checkedNote || t('ap.execute.checked', 'Plumme kontrollerer hvert bilag på nytt før det bokføres. Bilag som ikke holder mål blir stående i innboksen med en begrunnelse.')}
      </div>
    </div>
  </Modal>;
}

// «12.08.2026» fra en ISO-tid. Bare til rader som skal si naar noe ble signert.
const apArrayOf = (value) => Array.isArray(value) ? value : [];
// Hva handlingen skal utfores paa. Utledet ett sted, fordi den samme handlingen
// naa kan gaa to veier: rett gjennom HTTP, eller som en jobb i koen.
const apExecutionPayload = (task) => {
  const execution = task?.execution || {};
  if (execution.invoiceIds) return { invoiceIds: execution.invoiceIds };
  if (execution.lineIds) return { lineIds: execution.lineIds };
  if (execution.period) return { period: execution.period };
  if (execution.statementIds) return { statementIds: execution.statementIds };
  if (execution.contacts) return { types: execution.types, contacts: execution.contacts };
  if (execution.types) return { types: execution.types };
  if (execution.entryIds) return { entryIds: execution.entryIds };
  if (execution.expenseIds) return { expenseIds: execution.expenseIds, year: execution.year };
  if (execution.deadlineId) return { deadlineId: execution.deadlineId, incomeYear: execution.incomeYear };
  return {};
};
const apShortDate = (value) => {
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? ''
    : `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}`;
};

// Fingeravtrykkene som skal folge en samlet godkjenning. Koeoppgaver har sitt
// eget (`proposalSignature` i backend) og skal ikke ha et her.
const apBasisByTaskId = (tasks, ids) => {
  const wanted = new Set(ids || []);
  const out = {};
  (tasks || []).forEach((task) => {
    if (wanted.has(task.id) && task.basis) out[task.id] = task.basis;
  });
  return out;
};
// Hva som kan angres. En rad agenten selv klarerte har ingen signatur aa ta
// tilbake — der er «Aapne» veien videre. Sendte betalingspaaminnelser kan ikke
// kalles tilbake, og en maaned som er godkjent som helhet maa aapnes som maaned.
// Oppgaver der godkjenningen er en ekte innsending, ikke en signatur paa at
// noen har sett gjennom. MVA-raden kunne signeres uten at en eneste melding ble
// opprettet eller sendt — og neste gang raden ble aapnet var knappen borte,
// mens terminen fortsatt sto ulevert. Her aapnes meldingen i stedet.
// Signalet er terminene som staar igjen, ikke statusen paa raden: en signatur
// som allerede er gitt skal ikke kunne staa i veien for innsendingen den aldri
// gjorde.
const apTaskNeedsRealSubmission = (task) => (task?.kind === 'mva' && Number(task?.reviewCount) > 0 && Boolean(window.ApVatSurfaceModal))
  || (['taxSubmitted', 'annualAccountsSubmitted'].includes(task?.deadlineId) && Number(task?.reviewCount) > 0 && Boolean(window.ApYearEndSurfaceModal));
const apTaskReopenable = (task, status) =>
  Boolean(task?.approvedAt || status === 'approved')
  && task?.id !== 'purring' && !task?.queueGroup;

function ApTaskRow({ task, status, expanded, onToggle, onApprove, onView, onOpenRoute, onExecute, onReopen, onBookGroup, working = false, workflowBlocked = false }) {
  // Agenten hadde ingenting aa vurdere og er klarert av seg selv. Raden teller
  // som ferdig, men den er ikke en signatur noen har gitt — og skal derfor si
  // «automatisk», ikke bare «Godkjent».
  const autoCleared = task.autoCleared === true && status !== 'approved';
  const approved = status === 'approved' || task.status === 'done' || task.status === 'approved' || autoCleared;
  const taskLines = (task.backendBacked && Array.isArray(task.lines)) ? task.lines : ((typeof AP_TASK_LINES !== 'undefined' && AP_TASK_LINES[task.id]) || []);
  const correctionCount = taskLines.filter((line) => line.requiresCorrection || line.status === 'critical').length;
  const needsCorrection = task.requiresCorrection === true || correctionCount > 0;
  const kontrollCount = taskLines.filter((l) => l.status === 'kontroll' || l.status === 'mangler' || l.status === 'avvik').length;
  const needsControl = !needsCorrection && (task.status === 'needs_review' || kontrollCount > 0);
  // Gruppa arver den verste statusen til barna sine. Sto det bare «19 linjer må
  // kontrolleres» mens knappen sa «Godkjenn 1 forslag», leste de to som en
  // selvmotsigelse — begge var sanne, men raden fortalte bare halve tallet.
  const readyHere = typeof task.readyCount === 'number'
    ? task.readyCount
    : taskLines.filter((line) => line.status === 'matchet').length;
  const statusDetailText = [
    kontrollCount > 0 ? kontrollCount + (kontrollCount === 1
      ? t('ap.oneLineNeedsControl', ' linje må kontrolleres')
      : t('ap.manyLinesNeedControl', ' linjer må kontrolleres')) : '',
    readyHere > 0 && !approved
      ? t('ap.readyHere', '{{count}} er klar', { count: readyHere })
      : '',
  ].filter(Boolean).join(' · ');
  const reviewDetailText = task.statusDetail || statusDetailText;
  const isBlocked = task.disabled || task.status === 'blocked';
  // Ingen data aa vurdere: verken et funn eller en godkjenning.
  const idle = task.status === 'idle';
  // Sendingen er utfort i maaneden brukeren staar i. Da er «Godkjent» feil ord —
  // ingen signerte noe, det gikk e-post ut — og raden skal si nettopp det.
  const sentInPeriod = task.sentInPeriod || null;
  // Tidsbetingelsen er ikke oppfylt ennaa. Dette er ikke en kontroll brukeren
  // kan signere, og heller ikke et tomt kontrollresultat.
  const waiting = task.status === 'waiting';
  const agentLabel = apTaskAgentLabel(task);
  const blockedButActionable = isBlocked && task.monthControl;
  if (isBlocked) {
    return <div className={'ap-row' + (blockedButActionable ? '' : ' ap-row-disabled')}>
      <div className="ap-row-main">
        <div className="ap-row-task" data-help={t('aiHelp.autopilot.agent.body')} data-help-title={agentLabel}>
          <span className="ap-row-ico"><Icon name={task.icon} size={20} /></span>
          <span className="ap-row-task-copy">
            <span className="ap-row-title">{agentLabel}</span>
            {task.title && task.title !== agentLabel && <span className="ap-row-agent-note">{apRichText(task.title)}</span>}
          </span>
        </div>
        <div className="ap-row-desc">{task.desc || t('ap.rowDescMissing', 'Mangler informasjon før AI Regnskapsfører kan jobbe videre.')}</div>
        <div className="ap-row-status" data-help={t('aiHelp.autopilot.status.body')} data-help-title={t('aiHelp.autopilot.status.title')}>
          <span className={'ap-dot ' + (blockedButActionable ? 'warn' : 'off')} />
          <div><div className="ap-status-label">{t('ap.missingBasis')}</div><div className="ap-status-sub">{task.blockedReason || t('ap.rowBlockedReasonDefault', 'Krever oppsett eller data')}</div></div>
        </div>
        <div className="ap-row-actions">
          <Button size="sm" icon={task.route === 'bank' ? 'bank' : 'arrowRight'} onClick={() => task.monthControl ? onView(task) : onOpenRoute(task.route || 'bank')}>{task.actionLabel || t('ap.rowOpen', 'Åpne')}</Button>
          {/* En blokkert rad kunne ikke slås ut, så oppgaven som venter på
              bankutskrift kunne ikke vise hvilke kontoer det gjaldt. */}
          {taskLines.length > 0 && <button className="ap-chev" onClick={() => onToggle(task.id)} aria-label={t('ap.showDetails', 'Vis detaljer')} aria-expanded={Boolean(expanded)}>
            <Icon name={expanded ? 'chevUp' : 'chevDown'} size={18} />
          </button>}
        </div>
      </div>
      {expanded && taskLines.length > 0 && <div className="ap-row-detail">
        {task.detail && String(task.detail).split('\n').map((line, index) => <p key={index}>{line}</p>)}
        <div className="ap-blocked-lines">
          {taskLines.map((line) => <div key={line.id} className="ap-blocked-line">
            <div>
              <b>{line.title}</b>
              {line.sub && <div className="t-sm muted" style={{ fontWeight: 600 }}>{line.sub}</div>}
            </div>
            <Button size="sm" variant="secondary" icon="upload"
              onClick={() => task.monthControl ? onView(task) : onOpenRoute(line.route || task.route || 'bank')}>
              {t('ap.uploadStatement', 'Last opp utskrift')}
            </Button>
          </div>)}
        </div>
      </div>}
    </div>;
  }
  // Raden har to faste slots — godkjenningen og chevronen — slik at den krymper
  // forutsigbart. «Vis» og de lange, oppgavespesifikke handlingene («Åpne i
  // Bank», «Bokfør 12 bilag») ligger i panelet under, ikke i selve raden.
  // «Ingenting å kontrollere» er også en gjennomgang: agenten har sett etter og
  // ikke funnet noe. Brukeren skal kunne signere på det her, ikke bli sendt til
  // en tom flate — så `idle` godkjennes i raden på lik linje med resten.
  const canApproveHere = !needsCorrection && !approved && !autoCleared && !waiting && !workflowBlocked && !apTaskNeedsRealSubmission(task) && (
    idle || (task.queueTask && task.approvable) || !task.backendBacked
  );
  const approveHere = () => {
    // Raden signerer bare en kontroll. Bokforing og andre irreversible
    // handlinger gaar via agentens bekreftelsesdialog.
    void onApprove(task.id);
  };
  // Køgruppens handling hører
  // ikke hjemme på en Åpne-knapp.
  const primaryControlLabel = needsCorrection
    ? t('ap.followup.correct', 'Korriger')
    : task.queueGroup
    ? t('ap.openWorklist', 'Åpne arbeidslisten')
    : task.execution || task.route || taskLines.length
    ? t('ap.controlTask', 'Kontroller')
    : t('ap.showTask', 'Vis oppgave');
  return <div className={'ap-row' + (expanded ? ' open' : '') + (workflowBlocked ? ' ap-row-workflow-blocked' : '')}>
    <div className="ap-row-main">
      <div className="ap-row-task" data-help={t('aiHelp.autopilot.agent.body')} data-help-title={agentLabel}>
        <span className="ap-row-ico"><Icon name={task.icon} size={20} /></span>
        <span className="ap-row-task-copy">
          <span className="ap-row-title">{agentLabel}</span>
          {task.title && task.title !== agentLabel && <span className="ap-row-agent-note">{apRichText(task.title)}</span>}
        </span>
      </div>
      <div className="ap-row-desc">{task.desc}{task.due && <span className="ap-row-due"><Icon name="clock" size={13} />{t('ap.review.deadline', 'Frist')} · {task.due}</span>}</div>
      <div className="ap-row-status" data-help={t('aiHelp.autopilot.status.body')} data-help-title={t('aiHelp.autopilot.status.title')}>
        {/* `idle` betyr at agenten ikke hadde noe aa vurdere. Den skal ikke se ut
            som en gronn klar-til-godkjenning — da ville fravaer av data lest som
            en godkjenning. */}
        <span className={'ap-dot ' + (working ? 'working' : sentInPeriod ? 'sent' : approved ? 'done' : needsCorrection ? 'error' : needsControl ? 'warn' : waiting ? 'waiting' : idle ? 'off' : 'ready')} />
        <div>
          {/* Kjorer den akkurat naa, er det den eneste statusen som er sann. */}
          <div className={'ap-status-label' + (sentInPeriod && !working ? ' ap-status-sent' : '')}>{working ? t('ap.working') : sentInPeriod ? t('ap.sent') : needsCorrection ? t('ap.followup.mustCorrect', 'Må korrigeres') : autoCleared ? t('ap.nothingToCheck') : approved ? t(window.PlummeAutopilotReview.statusKey(task, status)) : needsControl ? t('ap.review.needsChecking') : waiting ? t('ap.waiting') : idle ? t('ap.nothingToCheck') : t('ap.review.readyForApproval')}</div>
          {/* `needs_review` fra backend uten en eneste flagget linje ga
              «0 linjer må kontrolleres». Tallet skal bare vises når det finnes. */}
          {sentInPeriod && !working
            ? <div className="ap-status-sub">{t('ap.sentCount', '{{count}} sendt', { count: sentInPeriod.count })}</div>
            : autoCleared
            ? <div className="ap-status-sub">{t('ap.autoApprovedDetail', 'Ingenting å kontrollere')}</div>
            : waiting
            ? <div className="ap-status-sub">{task.statusDetail || t('ap.waitingDetail', 'Kan ikke behandles ennå')}</div>
            : ((needsCorrection || needsControl) && !approved && reviewDetailText)
            ? <div className="ap-status-sub">{reviewDetailText}</div>
            : apConfPct(task) ? <div className="ap-status-sub">{t('apu.confidence', { pct: apConfPct(task) })}</div> : null}
          {/* Signaturen staar, men grunnlaget under den har endret seg. Raden
              viser derfor det agenten finner naa, og sier hvorfor den kom
              tilbake — ellers ser en godkjent oppgave ut til aa ha blitt aapnet
              av seg selv. */}
          {task.approvalStale && <div className="ap-status-sub ap-status-stale">
            {t('ap.staleApproval', 'Godkjent {{date}} · grunnlaget er endret siden', { date: apShortDate(task.approvedAt) })}
          </div>}
        </div>
      </div>
      {/* Kolonnen er godkjenningen. «Vis» ligger i det utslåtte panelet — den
          er en gjennomgang, ikke handlingen raden finnes for. */}
      <div className="ap-row-actions">
        {working
          ? <Button variant="secondary" size="sm" icon="clock" disabled>{t('ap.working', 'Jobber …')}</Button>
          /* Samme plass, samme form som «Godkjent» — men ordet skal si hva som
             faktisk skjedde. */
          : sentInPeriod
          ? <Button variant="secondary" size="sm" icon="check" disabled className="ap-approved-btn">{t('ap.sent', 'Sendt')}</Button>
          : autoCleared
          ? null
          : approved && !apTaskNeedsRealSubmission(task)
          ? <Button variant="secondary" size="sm" icon="check" disabled className="ap-approved-btn">{t(window.PlummeAutopilotReview.statusKey(task, status))}</Button>
          : canApproveHere
          ? <Button size="sm" icon="check" onClick={approveHere} data-help={t('helpTopics.aiProposal.body')} data-help-title={t('helpTopics.aiProposal.title')}>{t('ap.approve', 'Godkjenn')}</Button>
          : workflowBlocked
          ? <Button variant="secondary" size="sm" icon="lock" disabled>{t('ap.waitsForPrevious', 'Venter')}</Button>
          : waiting
          ? null
          : task.route
          // Oppgaver som må godkjennes på dypflaten kan ikke love godkjenning her.
          ? <Button size="sm" variant="secondary" icon="eye" onClick={() => onView(task)}>{primaryControlLabel}</Button>
          : null}
        <button className="ap-chev" onClick={() => onToggle(task.id)} aria-label={t('ap.showDetails', 'Vis detaljer')} aria-expanded={Boolean(expanded)}>
          <Icon name={expanded ? 'chevUp' : 'chevDown'} size={18} />
        </button>
      </div>
    </div>
    {expanded && <div className="ap-row-detail">
      {task.detail && String(task.detail).split('\n').map((line, index) => <p key={index}>{line}</p>)}
      <div className="ap-row-detail-actions">
        {/* Knappen aapner oppgaven, ikke en bilagsliste: «Vis bokførte linjer»
            lovet linjer selv paa agenter der modalen bare viser oppgaven. Ett
            navn for alle, og det parer med «Åpne side» ved siden av. */}
        <Button size="sm" variant="secondary" icon="eye" onClick={() => onView(task)}>
          {task.queueGroup ? t('ap.openWorklist', 'Åpne arbeidslisten') : t('ap.openTask', 'Åpne oppgave')}
        </Button>
        {/* «Aapne» i raden aapner arbeidsflaten over AI-siden. Denne er den
            navngitte veien helt inn paa siden — uten oppgave, saa den navigerer
            i stedet for aa aapne den samme modalen en gang til. */}
        {task.route && <Button size="sm" variant="secondary" icon="arrowRight" onClick={() => onOpenRoute(task.route)}>{t('ap.openPage', 'Åpne side')}</Button>}
        {!approved && task.execution && <Button size="sm" icon={task.id === 'faktura' ? 'send' : 'check'} onClick={() => task.id === 'faktura' ? onView(task) : onExecute(task)}>{task.id === 'faktura' ? t('ap.agent.invoice.choose', 'Velg fakturaer') : task.execution.label}</Button>}
        {/* Godkjenningen ligger i raden over. Sto den her ogsaa, var det to
            knapper for samme signatur — og tallet den manglet staar naa i
            statuslinjen («1 er klar»). */}
        {/* Bokforingen staar hos agenten den gjelder, ikke som en samleknapp
            over hele maaneden. Da ser du grunnlaget for det du fører, og
            «Bokfør» betyr én ting av gangen i stedet for alt paa en gang. */}
        {task.queueGroup && (task.approvable || task.executable) && onBookGroup
          && <Button size="sm" icon="book" onClick={() => onBookGroup(task)}>
            {task.approvable
              ? t('ap.approveAndBookProposals', 'Godkjenn og bokfør {{count}} forslag', { count: task.readyCount || 0 })
              : t('ap.book', 'Bokfør {{count}} forslag', { count: task.approvedCount || 0 })}
          </Button>}
        {/* En signatur brukeren ikke kommer ut av, toer de ikke gi. Angre-veien
            laa bare i «Vis oppgave»-modalen; den hoerer hjemme paa raden, ved
            siden av det den angrer. */}
        {approved && onReopen && apTaskReopenable(task, status)
          && <Button size="sm" variant="secondary" icon="refresh" onClick={() => void onReopen(task.id)}>
            {t('ap.reopenTask', 'Angre godkjenning')}
          </Button>}
      </div>
    </div>}
  </div>;
}

// En agent som ikke fant noe krever ingenting av brukeren. Foerst sto de som
// egne rader, saa som én sammenslaatt rad — men selv den ene raden er en linje
// brukeren maa lese seg forbi for aa finne det som faktisk venter paa noen.
// Lista viser derfor bare agenter med noe til kontroll. At de stille agentene
// gikk gjennom grunnlaget staar fortsatt i tellingen over lista — de teller som
// godkjent.
//
// Godkjenninger brukeren selv har signert (`approvedAt`) er ikke stille: der er
// raden kvitteringen for arbeidet som ble gjort, og den blir staaende.
const apTaskIsSelfClear = (task) => task.status === 'done' && !task.approvedAt
  && !task.keepVisibleWhenDone && !task.queueGroup && !task.queueTask;
const apTaskIsQuiet = (task) => task.status === 'idle' || task.wasIdle === true || apTaskIsSelfClear(task);
// Gruppa heter noe annet naar den bare inneholder agenter uten grunnlag enn naar
// den ogsaa inneholder agenter som kontrollerte noe og fant det i orden.
const apQuietAllIdle = (tasks) => tasks.every((task) => task.status === 'idle' || task.wasIdle === true);
// En agent som nettopp sendte noe er ikke stille. Sendingen gjor agenten tom i
// samme sekund — og uten dette forsvant raden brukeren nettopp handlet paa, med
// det eneste beviset paa at handlingen gikk gjennom.
const apTaskIsQuietRow = (task) => apTaskIsQuiet(task) && !task.sentInPeriod;

// Med én rad er «1 agenter fant ingenting» baade feil norsk og mindre nyttig enn
// agentens eget navn. Da settes navnet i tittelen, saa raden fortsatt kan
// identifiseres uten aa slaa den ut.
const apQuietGroupTitle = (tasks, { allIdle, waitingGroup }) => {
  if (tasks.length === 1) {
    const agent = apTaskAgentLabel(tasks[0]);
    return waitingGroup
      ? t('ap.waitingGroup.titleOne', '{{agent}} avventer', { agent })
      : allIdle
      ? t('ap.quiet.titleOne', '{{agent}} fant ingenting å kontrollere', { agent })
      : t('ap.quiet.titleClearOne', '{{agent}} fant ingenting å følge opp', { agent });
  }
  return waitingGroup
    ? t('ap.waitingGroup.title', '{{count}} agenter avventer', { count: tasks.length })
    : allIdle
    ? t('ap.quiet.title', '{{count}} agenter fant ingenting å kontrollere', { count: tasks.length })
    : t('ap.quiet.titleClear', '{{count}} agenter fant ingenting å følge opp', { count: tasks.length });
};

// Brukes i dag av gruppa med agenter som avventer perioden. Den samme raden
// dekker en gruppe stille agenter (`waitingGroup={false}`), men de tegnes ikke
// lenger i lista — se notatet over `apTaskIsSelfClear`.
function ApQuietGroupRow({ tasks, statuses, expanded, onToggle, onApprove, onApproveGroup, onView, onOpenRoute, onExecute, onReopen, onBookGroup, workingIds, loading, waitingGroup = false }) {
  // Radene i gruppa kan slaas ut hver for seg. Sammenslaaingen skal spare plass,
  // ikke ta fra brukeren muligheten til aa se hva agenten kontrollerte: en
  // godkjenning som kom av seg selv maa kunne aapnes og etterproeves.
  const [openChild, setOpenChild] = useState(null);
  const toggleChild = (id) => setOpenChild((current) => current === id ? null : id);
  // En agent som ikke fant noe klarerer seg selv. Gruppa hadde en Godkjenn-knapp
  // som signerte sju tomme lister paa en gang; det den sparte brukeren for var
  // seks klikk, men det ene som var igjen betydde ingenting.
  const isApproved = (task) => statuses[task.id] === 'approved' || task.status === 'done' || task.autoCleared === true;
  const pending = tasks.filter((task) => !isApproved(task));
  const allApproved = pending.length === 0;
  // Ingen i gruppa har en signatur bak seg. Da er «Godkjent» feil ord — det var
  // ingen som godkjente, det var bare ingenting aa godkjenne.
  const allAutoCleared = tasks.every((task) => task.autoCleared === true && statuses[task.id] !== 'approved');
  const allIdle = apQuietAllIdle(tasks);
  const names = tasks.map((task) => task.title).join(' · ');
  return <div className={'ap-row ap-row-quiet' + (expanded ? ' open' : '')}>
    <div className="ap-row-main">
      <div className="ap-row-task">
        <span className="ap-row-ico"><Icon name="checkCircle" size={20} /></span>
        <span className="ap-row-title">{apQuietGroupTitle(tasks, { allIdle, waitingGroup })}</span>
      </div>
      <div className="ap-row-desc">{names}</div>
      <div className="ap-row-status">
        <span className={'ap-dot ' + (waitingGroup ? 'waiting' : allApproved ? 'done' : 'off')} />
        <div>
          <div className="ap-status-label">{waitingGroup ? t('ap.waiting', 'Avventer') : allAutoCleared ? t('ap.autoApproved', 'Godkjent automatisk') : allApproved ? t('ap.approved') : t('ap.nothingToCheck', 'Ingenting å kontrollere')}</div>
          {waitingGroup
            ? <div className="ap-status-sub">{t('ap.waitingGroup.detail', 'Blir aktuelle når perioden er klar')}</div>
            : allAutoCleared
            ? <div className="ap-status-sub">{t('ap.autoApprovedDetail', 'Ingenting å kontrollere')}</div>
            : !allApproved && tasks.length !== pending.length
            && <div className="ap-status-sub">{t('ap.quiet.someApproved', '{{count}} godkjent', { count: tasks.length - pending.length })}</div>}
        </div>
      </div>
      <div className="ap-row-actions">
        {waitingGroup || allAutoCleared
          ? null
          : allApproved
          ? <Button variant="secondary" size="sm" icon="check" disabled className="ap-approved-btn">{t('ap.review.reviewApproved')}</Button>
          : <Button size="sm" icon="check" disabled={loading} onClick={() => void onApproveGroup(pending.map((task) => task.id))} data-help={t('helpTopics.aiProposal.body')} data-help-title={t('helpTopics.aiProposal.title')}>{t('ap.approve', 'Godkjenn')}</Button>}
        <button className="ap-chev" onClick={() => onToggle(waitingGroup ? '__waiting' : '__quiet')} aria-label={t('ap.showDetails', 'Vis detaljer')} aria-expanded={Boolean(expanded)}>
          <Icon name={expanded ? 'chevUp' : 'chevDown'} size={18} />
        </button>
      </div>
    </div>
    {/* Utslått viser gruppa de vanlige radene — samme oppgave, samme
        handlinger. Sammenslåingen skal spare plass, ikke gjemme noe. */}
    {expanded && <div className="ap-row-detail ap-row-quiet-list">
      {tasks.map((task) => <ApTaskRow key={task.id} task={task} status={statuses[task.id]}
        expanded={openChild === task.id} onToggle={toggleChild}
        onApprove={onApprove} onView={onView} onOpenRoute={onOpenRoute} onExecute={onExecute} onReopen={onReopen} onBookGroup={onBookGroup}
        working={(workingIds || []).includes(task.id)} />)}
    </div>}
  </div>;
}

// Autopilot-oppsettet hører til foretaket, ikke til nettleseren: det ligger i
// `settings.autopilot` og følger dermed brukeren mellom enheter. De to gamle
// localStorage-nøklene leses fortsatt som fallback så lenge `settings.autopilot`
// mangler, slik at ingen mister valget sitt. Første lagring skriver til backend.
// En agent uten grunnlag skal ikke staa i veien. Har foretaket ingen ansatte,
// finnes det ingen lonn aa foelge opp, og da gjor lonnsagenten regnskapet
// vanskeligere aa fullfore i stedet for lettere. Den kan ikke slaas paa, og
// oppgavene dens vises ikke.
//
// Merk at dette IKKE gjelder agenter som bare er tomme akkurat naa: en tom
// innboks er et resultat, ikke et fravaer av grunnlag, og skal vises som
// godkjent slik at brukeren ser at den er sjekket.
const apAgentRequirement = (key, state) => {
  if (key === 'lonn') {
    const employees = Array.isArray(state?.employees) ? state.employees : [];
    return employees.some((employee) => employee?.active !== false)
      ? null
      : t('ap.require.noEmployees', 'Ingen aktive ansatte er registrert.');
  }
  if (key === 'mva') {
    return state?.settings?.vatRegistered
      ? null
      : t('ap.require.noVat', 'Foretaket er ikke MVA-registrert.');
  }
  // Bankavstemming er et valg, ikke en plikt. Et lite enkeltpersonforetak som
  // bruker privatkontoen sin har ingen driftsutskrift aa avstemme, og skal ikke
  // ha tre bankagenter staaende og etterlyse en som aldri kommer.
  if (key === 'bilag' || key === 'avstemming') {
    return !window.apHasBankReconciliationScope?.(state)
      ? t('ap.require.noBankReconciliation', 'Ingen aktive bankkontoer er satt til avstemming.')
      : null;
  }
  return null;
};

// Hva SuperPlumma har lov til å gjøre
const AP_PERMS = [
  { key: 'bokforing', icon: 'bank', labelKey: 'ap.monthControl.label', descKey: 'ap.monthControl.permissionDesc', label: 'Bokføringsagenten', desc: 'Kategoriserer og bokfører banktransaksjoner automatisk.' },
  { key: 'innboks', icon: 'receipt', labelKey: 'ap.permission.inbox.label', descKey: 'ap.permission.inbox.desc', label: 'Innboksagenten', desc: 'Leser kvitteringer og fakturaer som kommer inn på e-post eller opplasting, og klargjør dem for bokføring.' },
  { key: 'bilag', icon: 'link', labelKey: 'ap.permission.matching.label', descKey: 'ap.permission.matching.desc', label: 'Bilagsagenten', desc: 'Kobler bilag fra innboksen mot banklinjer som mangler dokumentasjon, når treffet er entydig.' },
  { key: 'faktura', icon: 'fileText', labelKey: 'ap.permission.invoice.label', descKey: 'ap.permission.invoice.desc', label: 'Fakturaagenten', desc: 'Følger opp fakturautkast og ferdige fakturaer som ikke er sendt til kunden.' },
  { key: 'purring', icon: 'clock', labelKey: 'ap.permission.dunning.label', descKey: 'ap.permission.dunning.desc', label: 'Purreagenten', desc: 'Holder oversikt over forfalte fakturaer og hva som bør purres først.' },
  { key: 'oppfolging', icon: 'checkCircle', labelKey: 'ap.permission.followup.label', descKey: 'ap.permission.followup.desc', label: 'Oppfølgingsagenten', desc: 'Fanger opp opplysninger, kundedialoger og avvik som ikke hører til en innleveringsagent.' },
  { key: 'avstemming', icon: 'checkCircle', labelKey: 'ap.permission.reconciliation.label', descKey: 'ap.permission.reconciliation.desc', label: 'Avstemmingsagenten', desc: 'Passer på at hver avsluttet måned faktisk er avstemt og bokført mot driftsbanken.' },
  { key: 'kontroll', icon: 'alertCircle', labelKey: 'ap.permission.control.label', descKey: 'ap.permission.control.desc', label: 'Kontrollagenten', desc: 'Leter etter kjøp uten bilag og mulige dobbeltføringer i regnskapet.' },
  { key: 'frister', icon: 'clock', labelKey: 'ap.permission.deadline.label', descKey: 'ap.permission.deadline.desc', label: 'Fristagenten', desc: 'Varsler om innleveringsfrister som nærmer seg eller er oversittet.' },
  { key: 'kjorebok', icon: 'car', labelKey: 'ap.permission.mileage.label', descKey: 'ap.permission.mileage.desc', label: 'Kjørebokagenten', desc: 'Sjekker at yrkeskjøring er ført med strekning, formål og kilometer, slik at fradraget står seg.' },
  { key: 'eiendeler', icon: 'briefcase', labelKey: 'ap.permission.asset.label', descKey: 'ap.permission.asset.desc', label: 'Eiendelsagenten', desc: 'Foreslår driftsmiddel for større kjøp. Du velger kostnadsføring eller saldogruppe før samme bilag bokføres én gang.' },
  { key: 'leverandorer', icon: 'building', labelKey: 'ap.permission.vendor.label', descKey: 'ap.permission.vendor.desc', label: 'Leverandøragenten', desc: 'Oppretter nye leverandører når SuperPlumma oppdager gjentatte føringer fra samme leverandør.' },
  { key: 'kunder', icon: 'users', labelKey: 'ap.permission.customer.label', descKey: 'ap.permission.customer.desc', label: 'Kundeagenten', desc: 'Oppretter nye kunder når SuperPlumma oppdager salg til ukjente kunder.' },
  { key: 'mva', icon: 'percent', labelKey: 'ap.permission.vat.label', descKey: 'ap.permission.vat.desc', label: 'MVA-agenten', desc: 'Avstemmer MVA og klargjør MVA-meldingen for innsending.' },
  { key: 'skatt', icon: 'doc', labelKey: 'ap.permission.tax.label', descKey: 'ap.permission.tax.desc', label: 'Skatteagenten', desc: 'Forhåndsutfyller skattemeldingen basert på regnskapet ditt.' },
  { key: 'lonn', icon: 'wallet', labelKey: 'ap.permission.payroll.label', descKey: 'ap.permission.payroll.desc', label: 'Lønnsagenten', desc: 'Holder oversikt over lønnskjøringer som venter på godkjenning. Beregning og godkjenning gjøres i lønnsflaten.' },
  { key: 'arsregnskap', icon: 'files', labelKey: 'ap.permission.annual.label', descKey: 'ap.permission.annual.desc', label: 'Årsregnskapsagenten', desc: 'Klargjør årsregnskap og noter ved årsavslutning.' },
];
const AP_VISIBLE_PERMS = window.apVisibleMonthControlPerms(AP_PERMS);
function apGetPerms() {
  let saved = apStoredSettings()?.agents || null;
  if (!saved || typeof saved !== 'object') { try { saved = JSON.parse(localStorage.getItem(AP_PERMS_KEY)) || {}; } catch (e) { saved = {}; } }
  const out = {}; AP_PERMS.forEach((p) => { out[p.key] = saved[p.key] !== false; }); // default på
  return window.apNormalizeMonthControlPerms(saved, out);
}
function apSavePerms(p) { apPatchSettings({ agents: p }); }
function ApSettingsModal({ perms, setPerms, state, enabled, lastRun, bankImported, bankLabel, onOpenBank, onClose }) {
  // Agenter uten grunnlag kan verken telles eller slaas paa.
  const blocked = (key) => apAgentRequirement(key, state);
  const available = AP_VISIBLE_PERMS.filter((p) => !blocked(p.key));
  const onCount = available.filter((p) => perms[p.key]).length;
  const allOn = onCount === available.length;
  const toggle = (key) => {
    if (blocked(key)) { toast(blocked(key), 'info'); return; }
    setPerms((prev) => { const next = window.apToggleMonthControlPerms(prev, key); apSavePerms(next); return next; });
  };
  const setAll = (on) => setPerms((prev) => {
    const next = { ...prev };
    available.forEach((p) => window.apSetMonthControlPerm(next, p.key, on));
    apSavePerms(next);
    return next;
  });
  return <Modal open onClose={onClose} title={t('nav.aiBookkeeper')} max={620}
    footer={<Button onClick={onClose}>{t('clo.done')}</Button>}>
    <div className="col gap-10" style={{ paddingBottom: 4 }}>
      <section className="ap-settings-overview">
        <h3 className="t-h3">{t('nav.aiBookkeeper')}</h3>
        <p>{t('ap.aboutHelp')}</p>
        {enabled && lastRun && <div className="t-sm muted ap-last-run">
          <Icon name="clock" size={13} />
          <span>{t('ap.lastRunLabel')}</span><span className="ap-last-run-date">{window.PlummeI18n?.dateTime ? window.PlummeI18n.dateTime(lastRun) : String(lastRun).slice(0, 16).replace('T', ' ')}</span>
        </div>}
        <div className="ap-settings-bank">
          <span className="ap-bank-ico" style={{ opacity: bankImported ? 1 : 0.55 }}><Icon name="bank" size={24} /></span>
          <div className="grow" style={{ minWidth: 0 }}>
            <div className="ap-perm-label" data-help={t('ap.bankDataHelp')} data-help-title={t('ap.bankData')}>{t('ap.bankData')}</div>
            <div className="ap-perm-desc ap-bank-acct">{bankImported ? (bankLabel || t('ap.bankStatementImported')) : t('ap.noBankData')}</div>
          </div>
          {bankImported ? <Badge variant="success" dot>{t('ap.dataExists')}</Badge> : <Badge variant="error" dot>{t('ap.noData')}</Badge>}
          <Button variant="secondary" icon="bank" onClick={onOpenBank}>{bankImported ? t('bank.backToBank') : t('ap.importBankStatement')}</Button>
        </div>
      </section>
      <div className="ap-settings-agents-head">
        <h3 className="t-h3">{t('ap.whichAgents')}</h3>
        <span className="t-sm muted">{t('ap.settings.enabledCount', { on: onCount, total: available.length })}</span>
      </div>
      <div className="t-sm muted" style={{ fontWeight: 600, marginBottom: 2 }}>{t('ap.settings.intro')}</div>
      <div className="ap-perm ap-perm-all" data-help={t('aiHelp.autopilot.settings.body')} data-help-title={t('aiHelp.autopilot.settings.title')}>
        <span className="ap-perm-ico" style={{ background: 'var(--plum-600)', color: '#fff' }}><Icon name="sparkle" size={19} /></span>
        <div className="grow" style={{ minWidth: 0 }}>
          <div className="ap-perm-label">{t('ap.allAgents')}</div>
          <div className="ap-perm-desc">{t('ap.settings.allHelp', 'Aktiver eller deaktiver alle på én gang.')}</div>
        </div>
        <Switch on={allOn} onChange={() => setAll(!allOn)} />
      </div>
      {AP_VISIBLE_PERMS.map((p) => <div key={p.key} className={'ap-perm' + (blocked(p.key) ? ' ap-perm-blocked' : '')}
        data-help={t('aiHelp.autopilot.settings.body')} data-help-title={p.labelKey ? t(p.labelKey) : p.label}
        title={blocked(p.key) || undefined}>
        <span className="ap-perm-ico"><Icon name={p.icon} size={19} /></span>
        <div className="grow" style={{ minWidth: 0 }}>
          <div className="ap-perm-label">{p.labelKey ? t(p.labelKey) : p.label}</div>
          <div className="ap-perm-desc">{blocked(p.key) || (p.descKey ? t(p.descKey) : p.desc)}</div>
        </div>
        <Switch on={!blocked(p.key) && !!perms[p.key]} onChange={() => toggle(p.key)} />
      </div>)}
    </div>
  </Modal>;
}

function AiAutopilotPage({ year = 2026, setRoute, setYear }) {
  const backend = window.PlummeBackend?.useBackend ? window.PlummeBackend.useBackend() : null;
  // Maaneden maa vaere kjent for modellen: agentene filtrerer paa den, saa
  // modellen bygges paa nytt naar brukeren blar. `activeYear` kan derfor ikke
  // hentes fra modellen lenger — den utledes rett fra backend-staten.
  const resolvedYear = Number(backend?.appState?.activeYear || year) || Number(year);
  const [month, setMonth] = useState(() => apDefaultMonth(resolvedYear));
  useEffect(() => { setMonth(apDefaultMonth(resolvedYear)); }, [resolvedYear]);
  // Maanedsbytte bygger modellen paa nytt. Det er billig saa lenge de
  // underliggende backend-modellene er cachet per state (`cachedDerivedModel`) —
  // uten det ville hvert klikk kostet seks MVA-terminberegninger, to
  // arsrapporter og en gjennomgang av alle bilag, og paa iPad Safari blokkerer
  // det hovedtraden. Se `perf`-notatet i docs/features/superplumma-autopilot.md.
  // Bokforing kan ikke angres med et klikk, og skal derfor bekreftes.
  // Agentgruppa som venter paa bokforingsbekreftelse.
  const [bookGroup, setBookGroup] = useState(null);
  const model = useMemo(() => window.buildAiAutopilotModel?.({ year: resolvedYear, month }) || null,
    [backend?.appState, backend?.activeBusinessId, resolvedYear, month]);
  // Fingeravtrykk av lagret oppsett: speiler backend inn i lokal state uten å
  // skrive ved mount. Bryteren skrev tidligere ved hver mount, som ville betydd
  // en Firestore-skriving hver gang siden ble åpnet.
  const autopilotFingerprint = JSON.stringify(backend?.appState?.settings?.autopilot || null) + '|' + (backend?.activeBusinessId || '');
  const [on, setOn] = useState(apGetOn);
  useEffect(() => { setOn(apGetOn()); }, [autopilotFingerprint]);
  const toggleOn = (next) => { setOn(next); apSetOn(next); };
  const activeYear = model?.year || resolvedYear;
  const [showAllYearTasks, setShowAllYearTasks] = useState(false);
  useEffect(() => { setShowAllYearTasks(false); }, [activeYear, month]);
  const [statuses, setStatuses] = useState({}); // id -> 'approved'
  const [expanded, setExpanded] = useState(null); // id på raden som er slått ut
  const toggleExpanded = (id) => setExpanded((current) => current === id ? null : id);
  const [viewTask, setViewTask] = useState(null);
  const [perms, setPerms] = useState(apGetPerms);
  useEffect(() => { setPerms(apGetPerms()); }, [autopilotFingerprint]);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const activity = window.useApTaskActivity();
  const loading = activity.busy;
  const [executeTask, setExecuteTask] = useState(null);
  // Arbeidsflaten som staar aapen over siden: { kind, task }.
  const [surface, setSurface] = useState(null);
  useEffect(() => {
    const pending = window.__plummeReturnSurface || null;
    window.__plummeReturnSurface = null;
    if (!pending) return;
    if ((pending.appYear || pending.task?.appYear) && setYear) setYear(pending.appYear || pending.task.appYear);
    setSurface(pending);
  }, []);
  // Oppgaver som kjorer akkurat naa. Raden viser «Jobber …» i stedet for at en
  // modal blokkerer hele siden mens e-posten sendes. Lista fylles fra to
  // kilder: handlinger denne fanen startet, og jobber i koen — som kan ha blitt
  // bestilt fra en annen fane, eller for brukeren lastet siden paa nytt.
  const [workingIds, setWorkingIds] = useState([]);
  const [jobIds, setJobIds] = useState([]);
  const busyIds = [...new Set([...workingIds, ...jobIds, ...activity.taskIds])];
  // Jobber som faktisk sendte noe. Agenten blir stille i samme sekund sendingen
  // er gjort, og raden du nettopp handlet paa forsvant ut av lista — uten et
  // spor av at det gikk bra. Kvitteringen hentes fra jobbposten, ikke fra en
  // variabel i denne fanen: da taaler den at siden lastes paa nytt.
  const [sentJobs, setSentJobs] = useState([]);
  const [queueTasks, setQueueTasks] = useState([]);
  const [queueLoaded, setQueueLoaded] = useState(false);
  const [queueError, setQueueError] = useState(false);
  const queueRequest = useRef(0);
  // Sammendraget den planlagte jobben skriver. Brukes bare til «sist sett paa»,
  // ikke til tallene i lista — de skal folge det brukeren nettopp gjorde.
  const [lastRun, setLastRun] = useState('');
  useEffect(() => {
    let cancelled = false;
    window.PlummeBackend?.getAutopilotSummary?.().then((summary) => {
      if (!cancelled) setLastRun(summary?.at || '');
    });
    return () => { cancelled = true; };
  }, [backend?.activeBusinessId]);

  const hasBackendTasks = model?.source === 'backend';
  // Backend finnes, men state er ikke lastet ennå.
  const awaitingBackend = model?.source === 'loading';
  // Backend-koen eier bilagsbokforing og godkjenning av bankforslag. Den hentes
  // asynkront og legges foran de avledede oppgavene.
  const loadQueue = async ({ preferCache = false } = {}) => {
    if (!window.PlummeBackend?.getAutopilotTaskQueue || !backend?.activeBusinessId) { setQueueLoaded(true); return; }
    const request = ++queueRequest.current;
    try {
      const rows = await window.PlummeBackend.getAutopilotTaskQueue({ preferCache });
      if (request !== queueRequest.current) return;
      setQueueError(false);
      const grouped = window.apGroupAutopilotQueue ? window.apGroupAutopilotQueue(rows, { year: activeYear, month }) : [];
      const availableInbox = (backend?.appState?.receiptInbox || [])
        .filter((entry) => !['booked', 'trashed'].includes(entry.status))
        .map((entry) => ({
          id: entry.id,
          name: entry.attachmentName || entry.name || entry.subject || 'Bilag',
          meta: entry.receiptAnalysis?.supplierName || entry.received || entry.createdAt || '',
          amount: window.PlummeReceiptCurrency.grossNok(entry.receiptAnalysis) ?? undefined,
        }));
      setQueueTasks(grouped.map((group) => group.agentKey === 'bokforing' ? { ...group, inbox: availableInbox } : group));
    } catch (error) {
      if (request === queueRequest.current) setQueueError(true);
      console.error('Could not load the AI accountant queue.', error);
    } finally { if (request === queueRequest.current) setQueueLoaded(true); }
  };
  // Koen hentes paa nytt ved hver state-endring, men den forrige blir staaende
  // imens. Tidligere nullstilte vi `queueLoaded` forst, og da falt lista tilbake
  // til de avledede oppgavene i ett bilde for koen kom igjen — en full
  // omtegning av alle radene per lagring.
  useEffect(() => { void loadQueue({ preferCache: true }); return () => { queueRequest.current += 1; }; }, [backend?.activeBusinessId, backend?.appState, activeYear, month]);
  useEffect(() => { setQueueTasks([]); setQueueError(false); }, [backend?.activeBusinessId, activeYear, month]);

  // Jobber som kjorer i Functions. Siden folger bare med paa hvilke rader som
  // fortsatt staar paa, saa spinneren stemmer mens brukeren er her.
  //
  // Selve kvitteringen — «sendt» eller «stoppet, og hvorfor» — gis ikke her.
  // Den hoerer til okten og ligger i `useAutopilotJobReceipts` i app.jsx: laa
  // den paa denne siden, forsvant svaret i det brukeren gikk videre, og en
  // faktura som stoppet ble bare staaende usendt uten en grunn noe sted.
  useEffect(() => {
    if (!window.PlummeBackend?.watchAutopilotJobs) return undefined;
    const stop = window.PlummeBackend.watchAutopilotJobs((jobs) => {
      const running = jobs.filter((job) => job.status === 'queued' || job.status === 'running');
      setJobIds(running.map((job) => job.taskId).filter(Boolean));
      const finishedTaskIds = jobs
        .filter((job) => job.status === 'done' || job.status === 'failed')
        .map((job) => job.taskId)
        .filter(Boolean);
      if (finishedTaskIds.length) setWorkingIds((current) => current.filter((id) => !finishedTaskIds.includes(id)));
      // Bare jobber som fikk noe ut. "0 sendt" er ingen kvittering.
      setSentJobs(jobs
        .filter((job) => job.status === 'done' && job.taskId && Number(job.bookedCount) > 0)
        .map((job) => ({
          taskId: String(job.taskId),
          count: Number(job.bookedCount) || 0,
          at: String(job.finishedAt || job.requestedAt || ''),
        })));
    });
    return () => { if (typeof stop === 'function') stop(); };
  }, [backend?.activeBusinessId]);
  const sourceTasks = hasBackendTasks
    ? (queueLoaded && queueTasks.length
      ? [...queueTasks, ...model.tasks.filter((task) => !queueTasks.some((group) => group.agentKey === apTaskPermKey(task)) && task.id !== 'followup-inbox')]
      : model.tasks).filter((task) => task.requiresCorrection || perms[apTaskPermKey(task)] !== false)
      // En agent uten grunnlag skal ikke fylle lista. Har du ingen ansatte, er
      // en lonnsrad bare stoy paa veien til et ferdig regnskap.
      .filter((task) => !apAgentRequirement(apTaskPermKey(task), backend?.appState))
    : [];
  const mergedTasks = window.apMergeMonthControlTasks ? window.apMergeMonthControlTasks(sourceTasks, { year: activeYear, month }) : sourceTasks;
  // Utfort arbeid hoerer til maaneden det ble gjort i. Blar du videre, er det
  // ikke lenger denne maanedens arbeid — og raden skal ikke folge med.
  const sentByTask = new Map();
  sentJobs.forEach((job) => {
    const at = new Date(job.at);
    if (Number.isNaN(at.getTime())) return;
    if (at.getFullYear() !== Number(activeYear)) return;
    if (month != null && at.getMonth() !== Number(month)) return;
    const current = sentByTask.get(job.taskId);
    sentByTask.set(job.taskId, { count: (current?.count || 0) + job.count, at: job.at });
  });
  const tasks = sentByTask.size
    ? mergedTasks.map((task) => (sentByTask.has(task.id) ? { ...task, sentInPeriod: sentByTask.get(task.id) } : task))
    : mergedTasks;

  // Månedsseksjonen og årsseksjonen. Køoppgaver fra backend har ingen `scope`
  // og hører til måneden de dukket opp i — de behandles som månedsarbeid.
  //
  // Årsagentene (frister, register, skattegrunnlag, årsregnskap) vises bare når
  // brukeren står i inneværende måned. Blar du tilbake til januar for å gjøre
  // ferdig januar, skal ikke årsoppgjøret ligge og rope i samme liste.
  // Løpende arbeid — forfalte krav — vises uansett måned: det er penger som
  // står ute nå, ikke et problem som tilhører måneden det oppsto i.
  //
  // Unntaket er en årsoppgave som HAR en måned: en frist. Aksjonærregister-
  // oppgaven forfaller 31. januar, skattemeldingen 31. mai og årsregnskapet
  // 31. juli — blar du til den måneden, er fristen nettopp det som hører hjemme
  // der. `deadlineMonth` er den kalendermåneden, og settes bare av agenter som
  // faktisk har en dato. Resten oppfører seg som før.
  const isCurrentMonth = activeYear === apCurrentYear() && month === apCurrentMonth();
  const scopeOf = (task) => task.scope || 'month';
  const monthTasks = apSortWorkflowTasks(tasks.filter((task) => scopeOf(task) === 'month'));
  const yearTasks = apSortWorkflowTasks(tasks.filter((task) => scopeOf(task) === 'running'
    || (scopeOf(task) === 'year' && (isCurrentMonth || task.deadlineMonth === month))));
  const visibleTasks = [...monthTasks, ...yearTasks];
  const workflowStopTask = monthTasks.find(apTaskBlocksWorkflow) || null;
  const workflowStopRank = workflowStopTask ? apTaskWorkflowRank(workflowStopTask) : Infinity;
  const taskWorkflowBlocked = (task) =>
    Boolean(workflowStopTask) && apTaskWorkflowRank(task) > workflowStopRank && AP_WORKFLOW_BLOCKING.has(apTaskPermKey(task));
  const nextWorkflowTask = window.PlummeAutopilotReview.nextTask(visibleTasks, workflowStopTask);
  // Radene som krever noe av brukeren staar for seg. De stille agentene tegnes
  // ikke — verken som egne rader eller som en sammenslaatt rad.
  const monthLoudTasks = monthTasks.filter((task) => !apTaskIsQuietRow(task) && task.status !== 'waiting');
  // Aarsseksjonen foelger samme regel. En purreagent som ikke fant en eneste
  // forfalt faktura er like stille som en maanedsagent uten funn, og skal ikke
  // staa under «Gjelder hele aaret».
  const yearLoudTasks = yearTasks.filter((task) => !apTaskIsQuietRow(task) && task.status !== 'waiting');
  const yearWaitingTasks = yearTasks.filter((task) => task.status === 'waiting');
  // «Vis alle» gjelder radene som krever noe. Den samlede raden teller som én.
  const visibleYearLoudTasks = showAllYearTasks ? yearLoudTasks : yearLoudTasks.slice(0, 5);
  const monthWaitingTasks = monthTasks.filter((task) => task.status === 'waiting');

  // Oppsummeringen skal kunne kontrolleres mot lista under. Stille agenter som
  // ikke fant noe tegnes ikke der, og skal derfor heller ikke blaase opp totalen
  // eller bli omtalt som godkjent. Ventende agenter finnes i de utslagbare
  // grupperadene og teller fortsatt som agentoppfoeringer i lista.
  const listedTasks = [...monthLoudTasks, ...monthWaitingTasks, ...yearLoudTasks, ...yearWaitingTasks];
  const readyCount = hasBackendTasks
    ? listedTasks.filter((task) => task.status === 'ready' || task.status === 'needs_review').length
    : listedTasks.filter((task) => !task.disabled && statuses[task.id] !== 'approved').length;
  const approvedCount = hasBackendTasks
    ? listedTasks.filter((task) => task.status === 'done' || task.status === 'approved').length
    : listedTasks.filter((task) => !task.disabled && statuses[task.id] === 'approved').length;
  // «Bokfør» bokfører, og ingenting annet: kooppgaver backend har vurdert som
  // klare. Signaturer hoerer til «Godkjenn maaneden» og til Godkjenn-knappen i
  // hver rad — en knapp som heter Bokfor skal ikke signere noe i det skjulte.
  //
  // Utenfor: `needs_review` (noe maa faktisk sees paa), oppgaver med en egen
  // `execution` (de skal innom bekreftelsesdialogen for de bokforer), og alt som
  // maa gjores paa dypflaten — de har sin egen Aapne-knapp i den utslaatte raden.
  const queueChildren = visibleTasks.filter((task) => task.queueGroup).flatMap((task) => task.queueTasks || []);
  const bulkBookableTasks = queueChildren.filter((task) => task.status === 'approved' && task.executable);
  const longLabel = apMonthLong(month) + ' ' + activeYear;
  // Grønn og rød kommer fra modellen, som vurderer alle tolv månedene:
  // 'done' = ingenting utestående, 'review' = måneden har kontrollpunkter.
  const monthStatuses = model?.monthStatuses || [];
  const monthDone = (i) => monthStatuses[i] === 'done';
  const monthReview = (i) => monthStatuses[i] === 'review';
  // Maaneder for overtakelsen er ikke vaare. Verken gronn eller rod.
  const monthImported = (i) => monthStatuses[i] === 'imported';
  // Rod: en frist knyttet til maaneden er oversittet. Det er en annen beskjed
  // enn «noe staar igjen» — plikten er forfalt, ikke bare uferdig.
  const monthOverdue = (i) => monthStatuses[i] === 'overdue';
  const monthIsOpen = activeYear > apCurrentYear() || (activeYear === apCurrentYear() && month >= apCurrentMonth());
  const bankImported = Boolean(model?.bankImported);

  const approve = (id) => { setStatuses((s) => ({ ...s, [id]: 'approved' })); toast(t('apu.taskApproved'), 'success'); };
  // Selve utføringen ligger i Functions. Her sendes bare hva brukeren godkjente,
  // og svaret forteller hva som faktisk ble bokført og hva som ble hoppet over.
  // Handlingen kjores uten aa holde modalen aapen. Aa sende fem fakturaer tar
  // flere sekunder hos e-postleverandoren, og en modal som staar og maler i
  // mellomtiden ser ut som at siden har hengt seg. Modalen lukkes med en gang,
  // raden faar status «Jobber …», og resultatet kommer naar det kommer.
  //
  // NB: kallet lever i denne fanen. Lukker brukeren siden mens det staar paa,
  // kan handlingen bli avbrutt. En koe som overlever det maatte hatt en
  // jobbpost i Firestore og en arbeider i Functions — se notatet i
  // docs/features/superplumma-autopilot.md.
  const runExecution = async (requestedTask = null) => {
    const task = requestedTask?.execution ? requestedTask : executeTask;
    if (!task?.execution || workingIds.includes(task.id)) return;
    setExecuteTask(null);
    setWorkingIds((current) => [...new Set([...current, task.id])]);
    // Handlinger med utgaaende e-post bestilles som en jobb i stedet for aa
    // kjores mens brukeren venter. Da er de utfort selv om fanen lukkes i samme
    // sekund, og raden staar paa «Jobber …» til arbeideren melder tilbake.
    if (window.PlummeBackend?.autopilotActionIsQueued?.(task.execution.action)) {
      try {
        await window.PlummeBackend.queueAutopilotTask({
          taskId: task.id,
          action: task.execution.action,
          payload: apExecutionPayload(task),
        });
        toast(t('ap.execute.queued', 'Lagt i kø. Kjøres selv om du lukker siden.'), 'info');
      } catch (error) {
        setWorkingIds((current) => current.filter((id) => id !== task.id));
        toast(error?.message || t('ap.execute.queueFailed', 'Kunne ikke legge handlingen i kø.'), 'error');
      }
      return;
    }
    try {
      const result = await window.PlummeBackend.executeAutopilotTask({
        taskId: task.id,
        action: task.execution.action,
        payload: apExecutionPayload(task),
      });
      const booked = Array.isArray(result?.booked) ? result.booked.length : 0;
      const skipped = Array.isArray(result?.skipped) ? result.skipped.length : 0;
      const done = task.execution.doneLabel
        ? t('ap.execute.doneCount', '{{booked}} {{noun}}', { booked, noun: task.execution.doneLabel })
        : t('ap.execute.done', '{{booked}} bilag bokført', { booked });
      toast(skipped
        ? t('ap.execute.partialCount', '{{done}} {{skipped}} ble ikke utført og må følges opp.', { done, skipped })
        : done, skipped ? 'info' : 'success');
    } catch (error) {
      toast(error?.message || t('ap.execute.failed', 'Bokføringen ble ikke gjennomført.'), 'error');
    } finally {
      setWorkingIds((current) => current.filter((id) => id !== task.id));
    }
  };
  const requestExecution = (task) => task?.id === 'faktura' ? (setViewTask(null), void runExecution(task)) : setExecuteTask(task);
  // Arbeidsflaten aapnes over AI-siden naar vi har en modal for den. Uten
  // oppgave (f.eks. «Last opp utskrift» paa en blokkert rad) navigeres det som
  // for — den knappen skal til Bank-siden, ikke til en avstemming.
  // «Vis» paa en kogruppe er ikke en liste over bokforte linjer — det er
  // arbeidslista til agenten. Begge veier inn (Vis og Aapne) skal derfor til
  // den samme flaten; ellers viser den ene et sammendrag og den andre jobben.
  const apSurfaceKindFor = (task) => task?.monthControl ? 'bank'
    : !task?.queueGroup ? ''
    : task.agentKey === 'bokforing' ? 'bank'
    : task.agentKey === 'eiendeler' ? 'eiendeler'
    : 'innboks';
  const apSurfaceAvailable = (kind) => kind === 'bank' ? Boolean(window.ApBankSurfaceModal)
    : kind === 'eiendeler' ? Boolean(window.ApAssetSurfaceModal)
    : kind === 'innboks' ? Boolean(window.ApInboxSurfaceModal)
    : kind === 'mva' ? Boolean(window.ApVatSurfaceModal)
    : false;
  const viewTaskOrSurface = (task) => {
    if (task?.id === 'lonn' || task?.id === 'amelding') { setSurface({ kind: 'route', route: 'lonn', task }); return; }
    const kind = apSurfaceKindFor(task);
    if (kind && apSurfaceAvailable(kind)) { setSurface({ kind, task }); return; }
    if (task?.route === 'bank' && window.ApBankSurfaceModal) { setSurface({ kind: 'bank', task }); return; }
    if (window.taskUsesYearEndSurface(task) && window.ApYearEndSurfaceModal) { setSurface({ kind: 'year-end', task }); return; }
    setViewTask(task);
  };
  const openSurfaceOrRoute = (route, task) => {
    if (task?.id === 'frister') { setSurface({ kind: 'route', route: 'innsendinger', task }); return; }
    if (task && route === 'bank' && window.ApBankSurfaceModal) { setSurface({ kind: 'bank' }); return; }
    if (task && route === 'innboks' && window.ApInboxSurfaceModal) { setSurface({ kind: 'innboks' }); return; }
    if (task && route === 'eiendeler' && window.ApAssetSurfaceModal) { setSurface({ kind: 'eiendeler', task }); return; }
    if (task && route === 'innsendinger' && window.ApVatSurfaceModal) { setSurface({ kind: 'mva', task }); return; }
    if (task && window.routeUsesYearEndSurface(route) && window.ApYearEndSurfaceModal) { setSurface({ kind: 'year-end', task }); return; }
    // Maalet er en samlet flate: alt som maa gjoeres skal kunne gjoeres her.
    // Sidene uten en egen arbeidsflate monteres derfor som de er, over
    // AI-siden — heller siden i en modal enn en tur ut av oversikten.
    if (task && window.ApRouteSurfaceModal && window.apRouteSurfaceComponent?.(route)) {
      setSurface({ kind: 'route', route, task });
      return;
    }
    openRoute(route);
  };
  const openRoute = (route) => {
    if (!route) return;
    if (setRoute) {
      setRoute(route);
      return;
    }
    if (window.plummeNav) window.plummeNav(route);
  };
  const approveAutopilotTask = async (id) => {
    const task = tasks.find((candidate) => candidate.id === id);
    // Køgrupper godkjenner og bokforer forslag som backend fortsatt vurderer
    // som klare, med samme bekreftelsesflyt som agentens egen bokforingsknapp.
    if (task?.queueGroup && task.approvable) {
      await bookApproved(task);
      return;
    }
    // Alt annet godkjennes gjennom execution-laget i Functions, som skriver en
    // audit-post om hvem som godkjente hva og naar. Bokforer ingenting — det er
    // en signatur paa at brukeren har gaatt gjennom oppgaven.
    if (!model?.periodKey || !window.PlummeBackend?.executeAutopilotTask) {
      toast(t('apu.approvalNeedsCompany'), 'info');
      return;
    }
    if (!activity.begin([id])) return;
    try {
      await window.PlummeBackend.executeAutopilotTask({
        taskId: id,
        action: 'approve-period-task',
        // `basis` er fingeravtrykket av det agenten viste da brukeren signerte.
        // Uten det ville signaturen dekket alt som senere skjer i perioden.
        payload: { taskId: id, period: model.periodKey, scope: task?.scope || 'month', basis: task?.basis || '' },
      });
      toast(t('apu.theTaskApproved'), 'success');
    } catch (error) {
      // Backend nekter naar noe faktisk maa gjores forst (MVA, bankavstemming).
      // Da er meldingen derfra mer presis enn noe vi kunne formulert her.
      toast(error?.message || t('apu.approveFailed'), 'error');
    } finally { activity.finish(); }
  };

  // De stille agentene signeres samlet i én Firestore-transaksjon. Dermed blir
  // hele gruppen enten godkjent eller stående åpen, og audit-posten viser alle
  // agentene brukeren godkjente med samme klikk.
  const approveQuietTasks = async (ids) => {
    const taskIds = [...new Set((ids || []).filter(Boolean))];
    if (!taskIds.length) return;
    if (!model?.periodKey || !window.PlummeBackend?.executeAutopilotTask) {
      taskIds.forEach(approve);
      return;
    }
    if (!activity.begin(taskIds)) return;
    try {
      await window.PlummeBackend.executeAutopilotTask({
        taskId: 'quiet-review',
        action: 'approve-period-tasks',
        payload: { taskIds, period: model.periodKey,
          scopeByTaskId: window.apScopeByTaskId(tasks, taskIds), basisByTaskId: apBasisByTaskId(tasks, taskIds) },
      });
      toast(t('apu.agentChecksApproved', { count: taskIds.length }), 'success');
    } catch (error) {
      toast(error?.message || t('apu.approveChecksFailed'), 'error');
    } finally { activity.finish(); }
  };

  // Angrer en godkjenning. Signaturen slettes i backend med samme kontrollspor
  // som godkjenningen, og oppgaven faller tilbake til statusen agenten gav den.
  const reopenAutopilotTask = async (id) => {
    setStatuses((current) => { const next = { ...current }; delete next[id]; return next; });
    if (!model?.periodKey || !window.PlummeBackend?.executeAutopilotTask) return;
    if (!activity.begin([id])) return;
    try {
      await window.PlummeBackend.executeAutopilotTask({
        taskId: id,
        action: 'reopen-period-task',
        payload: { taskId: id, period: model.periodKey, scope: tasks.find((candidate) => candidate.id === id)?.scope || 'month' },
      });
      toast(t('ap.approvalReopened', 'Godkjenningen er opphevet. Oppgaven er åpen igjen.'), 'info');
    } catch (error) {
      toast(error?.message || t('ap.reopenTaskError', 'Kunne ikke åpne oppgaven igjen.'), 'error');
    } finally { activity.finish(); }
  };

  useEffect(() => {
    window.plummeNav = openRoute;
  }, [setRoute]);

  const bookApproved = async (group) => {
    const source = group ? (group.queueTasks || []) : bulkBookableTasks;
    const readyIds = source.filter((task) => task.status === 'ready' && task.approvable).map((task) => task.id);
    const approvedIds = source.filter((task) => task.status === 'approved' && task.executable).map((task) => task.id);
    const ids = [...new Set([...readyIds, ...approvedIds])];
    if (!ids.length || loading) return;
    if (!activity.begin([group?.id || 'book-approved'])) return;
    try {
      const result = await window.PlummeBackend.approveAndBookAutopilotTasks({ readyTaskIds: readyIds, approvedTaskIds: approvedIds });
      const executeIds = [...new Set([...readyIds, ...approvedIds])];
      setQueueTasks(window.apGroupAutopilotQueue(result.tasks || [], { year: activeYear, month }));
      toast(t('ap.proposalsBookedToast', '{{count}} forslag er godkjent og bokført.', { count: result.executed?.length || executeIds.length }), 'success');
    } catch (error) {
      toast(error?.message || t('ap.approveBookError', 'Kunne ikke godkjenne og bokføre forslagene.'), 'error');
    } finally { activity.finish(); }
  };

  const updateQueueProposal = async (taskId, proposal) => {
    if (!activity.begin([tasks.find((task) => task.queueTasks?.some((child) => child.id === taskId))?.id || taskId])) return;
    try {
      const result = await window.PlummeBackend.updateAutopilotTaskProposal(taskId, proposal);
      setQueueTasks(window.apGroupAutopilotQueue(result.tasks || [], { year: activeYear, month }));
      toast(t('ap.proposalUpdatedToast', 'Forslaget er oppdatert og må godkjennes på nytt.'), 'success');
      return result.task;
    } catch (error) {
      toast(error?.message || t('apu.updateProposalFailed'), 'error');
      return null;
    } finally { activity.finish(); }
  };

  const ignorePeriodItem = async (taskId, itemOrIds, mode = 'next-month') => {
    if (!model?.periodKey) return false;
    if (!activity.begin([taskId])) return;
    const itemIds = (Array.isArray(itemOrIds) ? itemOrIds : [itemOrIds]).filter(Boolean);
    if (!itemIds.length) { activity.finish(); return false; }
    try {
      await window.PlummeBackend.executeAutopilotTask({
        taskId,
        action: 'ignore-period-item',
        payload: { taskId, ...(itemIds.length === 1 ? { itemId: itemIds[0] } : { itemIds }), period: model.periodKey, mode },
      });
      toast(itemIds.length > 1
        ? t('ap.linesSkippedToast', '{{count}} punkter er hoppet over.', { count: itemIds.length })
        : mode === 'always'
        ? t('ap.lineIgnoredToast', 'Dette punktet er ignorert. Nye oppfølgingspunkter vil fortsatt vises.')
        : t('ap.lineHiddenToast', 'Punktet er skjult denne måneden og kommer tilbake neste måned hvis det fortsatt er åpent.'), 'info');
      return true;
    } catch (error) {
      toast(error?.message || t('apu.postponeFailed'), 'error');
      return false;
    } finally { activity.finish(); }
  };

  const executeOneLine = (task, itemId) => {
    if (!task?.execution) return;
    setViewTask(null);
    requestExecution({
      ...task,
      execution: {
        ...task.execution,
        count: 1,
        invoiceIds: [itemId],
        label: task.id === 'purring' ? t('ap.sendReminder', 'Send påminnelse') : t('ap.sendInvoice', 'Send faktura'),
      },
    });
  };

  const executeContacts = (task, contacts) => {
    if (!task?.execution || !contacts?.length) return;
    setExecuteTask({ ...task, execution: { ...task.execution, contacts, count: contacts.length } });
  };

  const attachReceiptToQueueLine = async (statementId, lineId, receiptId) => {
    if (!statementId || !lineId || !receiptId) return false;
    if (!activity.begin([viewTask?.id || 'month-control'])) return;
    try {
      await window.PlummeBackend.attachReceiptToBankLine(statementId, lineId, receiptId);
      toast(t('ap.voucherLinkedToast', 'Bilaget er koblet til banklinjen. Forslaget vurderes på nytt.'), 'success');
      return true;
    } catch (error) {
      toast(error?.message || t('apu.linkVoucherFailed'), 'error');
      return false;
    } finally { activity.finish(); }
  };

  const saveMileageFromAgent = async (value) => {
    if (!value?.date || !String(value.fromLocation || '').trim() || !String(value.toLocation || '').trim()
      || !String(value.purpose || '').trim() || !(Number(value.kilometers) > 0)) {
      toast(t('ap.mileageFillRequired', 'Fyll ut dato, fra, til, formål og kilometer.'), 'error');
      return false;
    }
    const rows = backend?.appState?.mileageEntries || [];
    const next = rows.map((entry) => entry.id === value.id ? {
      ...entry,
      date: value.date,
      fromLocation: String(value.fromLocation).trim(),
      toLocation: String(value.toLocation).trim(),
      purpose: String(value.purpose).trim(),
      kilometers: Number(value.kilometers),
      amountNet: Math.round(Number(value.kilometers) * Number(entry.ratePerKm || window.MILEAGE_RATE || 3.5)),
    } : entry);
    if (!window.clientStore?.set) {
      toast(t('ap.mileageSaveUnavailable', 'Lagring av kjørebok er ikke tilgjengelig.'), 'error');
      return false;
    }
    await Promise.resolve(window.clientStore.set(backend?.activeBusinessId || window.PlummeBackend?.activeBusinessId || 'active', 'mileage', next)); // clientStore.set only writes for the active business id; 'active' silently dropped the save
    toast(t('ap.mileageUpdatedToast', 'Kjøreturen er oppdatert.'), 'success');
    return true;
  };
  return <div className="ap-page">
    {/* header */}
    <div className="ap-head">
      <div className="row gap-12" style={{ alignItems: 'center' }}>
        <h2 className="t-h1">{t('nav.aiBookkeeper')}</h2>
        <span className="ap-beta">{t('ap.beta')}</span>
      </div>
    </div>

    {/* banner */}
    <div className="ap-banner">
      <img className="ap-banner-img" src="src/img/SuperPlumma.png" alt="" />
      <div className="ap-banner-copy">
        <div className="ap-banner-title">{t('ap.heroTitle')}</div>
        <div className="ap-banner-sub">{t('ap.heroSub')}</div>
      </div>
      <div className="ap-banner-actions">
        <span className="ap-banner-switch-label" data-help={t('ap.aboutHelp')} data-help-title={t('nav.aiBookkeeper')}>{t('nav.aiBookkeeper')}</span>
        <Switch on={on} onChange={toggleOn} />
        <button className="ap-gear" onClick={() => setSettingsOpen(true)} title={t('ap.whatShouldDo')}
          data-help={t('aiHelp.autopilot.settings.body')} data-help-title={t('aiHelp.autopilot.settings.title')}><Icon name="settings" size={18} /></button>
      </div>
    </div>

    {/* month selector */}
    <Card pad={false} className="ap-months" data-help={t('ap.monthPickerHelp')} data-help-title={t('ap.monthOverview')}>
      <div className="ap-month-list">
        {AP_MONTHS.map((m, i) => <button key={i}
          className={'ap-month' + (i === month ? ' on' : '') + (monthDone(i) ? ' done' : '') + (monthReview(i) ? ' review' : '') + (monthOverdue(i) ? ' overdue' : '') + (monthImported(i) ? ' imported' : '')}
          title={monthImported(i)
            ? t('ap.monthImported', 'Ført i et annet system')
            : monthOverdue(i)
            ? t('ap.monthOverdue', 'En frist i denne måneden er oversittet')
            : monthReview(i)
            ? t('ap.monthReviewHint', 'Ikke ferdig — noe står igjen i måneden')
            : undefined}
          onClick={() => setMonth(i)}>
          {monthDone(i) ? <Icon name="check" size={13} className="ap-month-check" />
            : monthOverdue(i) ? <Icon name="alertCircle" size={13} className="ap-month-check" />
            : monthReview(i) ? <Icon name="alertCircle" size={13} className="ap-month-check" />
            : monthImported(i) ? <Icon name="database" size={13} className="ap-month-check" /> : null}{apMonthShort(i)}
        </button>)}
      </div>
    </Card>

    {queueError && <div className="bg-note warn" role="alert"><Icon name="alertTri" size={18}/><span>{t('ap.review.queueError')}</span><Button variant="secondary" onClick={() => void loadQueue()}>{t('ap.review.retry')}</Button></div>}

    {/* tasks */}
    <Card pad={false} className="ap-tasks">
      {awaitingBackend ? <div className="ap-empty">
        <img className="ap-empty-img" src="src/img/SuperPlumma.png" alt="" />
        <div className="ap-empty-title">{t('ap.loadingTitle')}</div>
        <div className="ap-empty-text">{t('ap.loadingText')}</div>
      </div> : visibleTasks.length === 0 ? <div className="ap-empty">
        <img className="ap-empty-img" src="src/img/SuperPlumma.png" alt="" />
        <div className="ap-empty-title">{t('ap.noActiveAgents')}</div>
        <div className="ap-empty-text">{t('ap.noActiveAgentsText', 'SuperPlumma står klar, men ingen agenter er aktivert akkurat nå. Aktiver agentene du vil bruke i innstillingene over, så setter teamet i gang med regnskapet ditt.')}</div>
        <Button icon="settings" onClick={() => setSettingsOpen(true)}>{t('ap.activateAgents')}</Button>
      </div> : <React.Fragment>
      <div className="ap-tasks-hd">
        <div>
          <h3 className="t-h2" style={{ fontSize: 24 }}>{longLabel}</h3>
          <div className="t-sm muted" style={{ marginTop: 3, fontWeight: 600 }}>{t('ap.monthSummaryHelp')}</div>
        </div>
        <div className="ap-tasks-stats">
          <ApStat label={t('ap.agents')} value={t(listedTasks.length === 1 ? 'ap.agentCount' : 'ap.agentCountPlural', { count: listedTasks.length })} help={t('ap.totalTasksHelp')} />
          <ApStat label={t('ap.readyForApproval')} value={readyCount} tone={readyCount ? 'warn' : ''} help={t('ap.readyForApprovalHelp')} />
          <ApStat label={t('ap.review.completed')} value={approvedCount} tone={approvedCount ? 'ok' : ''} help={t('ap.approvedHelp')} />
        </div>
      </div>

      {!queueError && nextWorkflowTask && <div className={'ap-next-step' + (['blocked', 'waiting'].includes(nextWorkflowTask.status) ? ' blocked' : '')}
        data-help={t('aiHelp.autopilot.next.body')} data-help-title={t('aiHelp.autopilot.next.title')}>
        <div className="ap-next-step-copy">
          <span className="ap-next-kicker">{t('ap.nextStep', 'Neste steg')}</span>
          <b>{apTaskAgentLabel(nextWorkflowTask)}</b>
          <span>{nextWorkflowTask.status === 'waiting'
            ? (nextWorkflowTask.statusDetail || t('ap.waitingDetail', 'Kan ikke behandles ennå'))
            : nextWorkflowTask.status === 'blocked'
            ? (nextWorkflowTask.blockedReason || t('ap.missingBasis', 'Mangler grunnlag'))
            : nextWorkflowTask.desc}</span>
        </div>
        {nextWorkflowTask.status === 'waiting'
          ? <Button variant="secondary" icon="clock" disabled>{t('ap.comeBackLater', 'Kom tilbake senere')}</Button>
          : <Button icon={nextWorkflowTask.status === 'blocked' && nextWorkflowTask.monthControl ? 'bank' : 'eye'}
              onClick={() => viewTaskOrSurface(nextWorkflowTask)}>
              {nextWorkflowTask.status !== 'blocked'
                ? t('ap.controlTask', 'Kontroller')
                : nextWorkflowTask.monthControl
                ? t('ap.getBankData', 'Hent bankdata')
                : t('ap.solveBlocker', 'Løs blokkering')}
            </Button>}
      </div>}

      {monthIsOpen && <div className="ap-period-warn" data-help={t('aiHelp.autopilot.openPeriod.body')} data-help-title={t('aiHelp.autopilot.openPeriod.title')}>
        <Icon name="alertCircle" size={18} />
        <div>
          <b>{t('ap.agent.reconcile.titleMonthOpen', '{{month}} er ikke avsluttet ennå', { month: apMonthLong(month) })}</b>
          <div className="ap-period-warn-sub">{t('ap.monthOpenHelp')}</div>
        </div>
      </div>}

      <div className="ap-table-cols">
        <span data-help={t('ap.taskColumnHelp')} data-help-title={t('ap.agents', 'Agenter')}>{t('ap.agents', 'Agenter')}</span><span data-help={t('aiHelp.autopilot.description.body')} data-help-title={t('aiHelp.autopilot.description.title')}>{t('ap.descriptionColumn', 'Beskrivelse')}</span><span data-help={t('ap.statusColumnHelp')} data-help-title={t('ap.statusColumn', 'Status')}>{t('ap.statusColumn', 'Status')}</span><span data-help={t('ap.actionColumnHelp')} data-help-title={t('ap.actionColumn', 'Handling')}>{t('ap.actionColumn', 'Handling')}</span>
      </div>
      <div className="ap-rows">
        {monthLoudTasks.map((task) => <ApTaskRow key={task.id} task={task} status={statuses[task.id]}
          expanded={expanded === task.id} onToggle={toggleExpanded}
          onApprove={approveAutopilotTask} onView={viewTaskOrSurface} onOpenRoute={openSurfaceOrRoute} onBookGroup={setBookGroup} onExecute={requestExecution} onReopen={reopenAutopilotTask} working={busyIds.includes(task.id)} workflowBlocked={taskWorkflowBlocked(task)} />)}
        {/* Her sto de stille agentene, samlet i én rad. Fant de ingenting, er
            det ingenting aa vise: raden blir en linje til aa lese seg forbi. */}
        {monthWaitingTasks.length > 0
          ? <ApQuietGroupRow tasks={monthWaitingTasks} statuses={statuses} loading={loading} waitingGroup
              expanded={expanded === '__waiting'} onToggle={toggleExpanded}
              onApprove={approveAutopilotTask} onApproveGroup={approveQuietTasks}
              onView={viewTaskOrSurface} onOpenRoute={openSurfaceOrRoute} onBookGroup={setBookGroup} onExecute={requestExecution} onReopen={reopenAutopilotTask} workingIds={busyIds} />
          : monthWaitingTasks.map((task) => <ApTaskRow key={task.id} task={task} status={statuses[task.id]}
              expanded={expanded === task.id} onToggle={toggleExpanded}
              onApprove={approveAutopilotTask} onView={viewTaskOrSurface} onOpenRoute={openSurfaceOrRoute} onBookGroup={setBookGroup} onExecute={requestExecution} onReopen={reopenAutopilotTask} working={busyIds.includes(task.id)} workflowBlocked={taskWorkflowBlocked(task)} />)}
        {/* Er alt i maaneden stille, staar lista tom — og en tom liste uten et
            ord leser som at siden ikke fikk lastet noe. Linjen under er svaret
            paa hvorfor det ikke staar noe der. */}
        {!monthLoudTasks.length && !monthWaitingTasks.length
          && <div className="ap-scope-empty">{t('ap.monthEmpty', 'Ingenting står igjen i {{month}}.', { month: longLabel })}</div>}
      </div>
      {/* Seksjonen finnes for arbeidet som ikke hoerer til én maaned. Er alt der
          stille, er det ingen seksjon aa vise — bare en overskrift over tomrom. */}
      {(yearLoudTasks.length > 0 || yearWaitingTasks.length > 0) && <React.Fragment>
        <div className="ap-scope-head" data-help={t('aiHelp.autopilot.yearScope.body')} data-help-title={t('aiHelp.autopilot.yearScope.title')}>
          <h4>{t('ap.yearScope', 'Gjelder hele året')}</h4>
          <span>{t('ap.yearScopeHelp', 'Arbeid som ikke hører til én måned — forfalte krav, frister, register og årsoppgjør.')}</span>
        </div>
        <div className="ap-rows">
          {visibleYearLoudTasks.map((task) => <ApTaskRow key={task.id} task={task} status={statuses[task.id]}
            expanded={expanded === task.id} onToggle={toggleExpanded}
            onApprove={approveAutopilotTask} onView={viewTaskOrSurface} onOpenRoute={openSurfaceOrRoute} onBookGroup={setBookGroup} onExecute={requestExecution} onReopen={reopenAutopilotTask} working={busyIds.includes(task.id)} workflowBlocked={taskWorkflowBlocked(task)} />)}
          {yearWaitingTasks.length > 0
            ? <ApQuietGroupRow tasks={yearWaitingTasks} statuses={statuses} loading={loading} waitingGroup
                expanded={expanded === '__yearWaiting'} onToggle={() => toggleExpanded('__yearWaiting')}
                onApprove={approveAutopilotTask} onApproveGroup={approveQuietTasks}
                onView={viewTaskOrSurface} onOpenRoute={openSurfaceOrRoute} onBookGroup={setBookGroup} onExecute={requestExecution} onReopen={reopenAutopilotTask} workingIds={busyIds} />
            : yearWaitingTasks.map((task) => <ApTaskRow key={task.id} task={task} status={statuses[task.id]}
                expanded={expanded === task.id} onToggle={toggleExpanded}
                onApprove={approveAutopilotTask} onView={viewTaskOrSurface} onOpenRoute={openSurfaceOrRoute} onBookGroup={setBookGroup} onExecute={requestExecution} onReopen={reopenAutopilotTask} working={busyIds.includes(task.id)} workflowBlocked={taskWorkflowBlocked(task)} />)}
          {yearLoudTasks.length > 5 && <div className="ap-year-toggle">
            <Button variant="ghost" size="sm" onClick={() => setShowAllYearTasks((current) => !current)}>
              {showAllYearTasks
                ? t('ap.showFewerYearTasks', 'Vis færre')
                : t('ap.showAllYearTasks', 'Vis alle ({{count}})', { count: yearLoudTasks.length })}
            </Button>
          </div>}
        </div>
      </React.Fragment>}
      </React.Fragment>}
    </Card>

    {viewTask && ((viewTask.id === 'leverandorer' || viewTask.id === 'kunder') && viewTask.execution
      ? <ApContactsModal task={viewTask} busy={loading} onClose={() => setViewTask(null)} onExecute={executeContacts} onSkipItem={ignorePeriodItem} />
      : <ApLinesModal task={viewTask} approved={statuses[viewTask.id] === 'approved' || viewTask.status === 'done'}
          // Bare en godkjenning brukeren selv har gitt kan angres. En køoppgave
          // som er ferdig fordi den er bokført har ingen signatur å fjerne.
          reopenable={apTaskReopenable(viewTask, statuses[viewTask.id])}
          busy={loading} onClose={() => setViewTask(null)} onApprove={approveAutopilotTask} onReopen={reopenAutopilotTask}
          onOpenSurface={(task) => openSurfaceOrRoute(task.route, task)}
          onUpdateProposal={updateQueueProposal} onIgnoreItem={ignorePeriodItem} onExecute={requestExecution} onExecuteLine={executeOneLine}
          onAttachReceipt={attachReceiptToQueueLine} onSaveMileage={saveMileageFromAgent} />)}
    {/* Arbeidsflatene. De bokforer selv, i den samme flyten som paa sin egen
        side — og laster koen paa nytt naar de lukkes, saa tallene over stemmer
        med det som faktisk ble gjort. */}
    {surface?.kind === 'bank' && window.ApBankSurfaceModal
      && <window.ApBankSurfaceModal month={month} year={activeYear} task={surface.task || tasks.find((task) => task.monthControl)}
          onOpenTask={(task) => task?.id === 'eiendeler' || task?.agentKey === 'eiendeler' ? setSurface({ kind: 'eiendeler', task }) : (setSurface(null), setViewTask(task))}
          onClose={() => setSurface(null)} onChanged={loadQueue} />}
    {surface?.kind === 'innboks' && window.ApInboxSurfaceModal
      && <window.ApInboxSurfaceModal year={activeYear} onClose={() => setSurface(null)} onChanged={loadQueue} />}
    {surface?.kind === 'eiendeler' && window.ApAssetSurfaceModal
      && <window.ApAssetSurfaceModal task={surface.task} year={activeYear}
          onClose={() => setSurface(null)} onChanged={loadQueue} />}
    {/* MVA godkjennes ikke med et hakk i raden — den godkjennes ved at
        meldingen faktisk opprettes, sendes inn og signeres. */}
    {surface?.kind === 'mva' && window.ApVatSurfaceModal
      && <window.ApVatSurfaceModal task={surface.task} year={activeYear}
          onClose={() => setSurface(null)} onChanged={loadQueue} />}
    <window.ApYearEndSurfaceHost surface={surface} year={activeYear} setYear={setYear} setSurface={setSurface} openRoute={openRoute} onChanged={loadQueue}/>
    {surface?.kind === 'route' && window.ApRouteSurfaceModal
      && <window.ApRouteSurfaceModal route={surface.route} year={activeYear} task={surface.task} setYear={setYear}
          onClose={() => setSurface(null)} onChanged={loadQueue} />}
    {settingsOpen && <ApSettingsModal perms={perms} setPerms={setPerms} state={backend?.appState}
      enabled={on} lastRun={lastRun} bankImported={bankImported} bankLabel={model?.bankLabel}
      onOpenBank={() => { setSettingsOpen(false); openRoute('bank'); }} onClose={() => setSettingsOpen(false)} />}
    {executeTask?.execution && <ApExecuteModal task={executeTask} running={false}
      onConfirm={runExecution} onClose={() => setExecuteTask(null)} />}
    {/* Bokforing fra toppknappen gikk rett i regnskapet uten et eneste
        mellomsteg. Den er den ene handlingen her som ikke kan angres med et
        klikk, og bruker derfor samme bekreftelse som agentenes egne. */}
    {bookGroup && <ApExecuteModal
      task={{ execution: {
        label: bookGroup.approvable
          ? t('ap.approveAndBookProposals', 'Godkjenn og bokfør {{count}} forslag', { count: bookGroup.readyCount || 0 })
          : t('ap.book', 'Bokfør {{count}} forslag', { count: bookGroup.approvedCount || 0 }),
      } }}
      running={loading}
      onConfirm={() => { const group = bookGroup; setBookGroup(null); void bookApproved(group); }}
      onClose={() => setBookGroup(null)} />}

  </div>;
}

Object.assign(window, { AiAutopilotPage, apGetOn });
window.dispatchEvent?.(new CustomEvent('plumme-page-registered', { detail: { pages: ['AiAutopilotPage'] } }));
